/* ============================================================
   SOURCE OF TRUTH — edit this file only (theme asset).
   Loaded via snippets/pfbx-plp-custom-assets.liquid
   Do NOT paste into Prefixbox Custom js.
   Includes remount repair (Categories + toggles after Prefixbox refresh).
   ============================================================ */

/* Guard: never run twice */
if (window.__PFBX_PLP_CUSTOM__) {
  /* already loaded */
} else {
window.__PFBX_PLP_CUSTOM__ = true;

/* ============================================================
   Prefixbox Custom JS — PRODUCTION (desktop toggles FIXED)

   Desktop: In Stock / Deals / Sale stay INSIDE Availability + Tags
   Mobile:  separate .pfbx-mobile-drawer-toggles — NEVER moves desktop nodes
   ============================================================ */

/* ============================================================
   IWISH
   ============================================================ */

   const HEART_FILLED = '<rect fill="none" height="256" width="256"></rect><path d="M128,216S28,160,28,92A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92C228,160,128,216,128,216Z" fill="#000" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></path>';
   const HEART_EMPTY = '<rect fill="none" height="256" width="256"></rect><path d="M128,216S28,160,28,92A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92C228,160,128,216,128,216Z" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></path>';
   
   const pfbxIsInWishlist = (variantId) => {
       if (!window.iWish || !window.iWish.iWishlist) return false;
       return window.iWish.iWishlist.has(String(variantId));
   };

   /* ============================================================
      Scissors-only facets (after Vendor): Length, Blade Shape,
      Application, Cutting Edge, Tip Style, Coating, …
      Show ONLY on Scissors + Level-4 child collections.
      ============================================================ */
   const PFBX_SCISSORS_FILTER_HANDLES = new Set([
       'scissors',
       'kelly-scissors',
       'dean-scissors',
       'metzenbaum-scissors',
       'goldman-fox-scissors',
       'lagrange-scissors',
       'iris-scissors',
       'suture-scissors-b-all-families',
       'suture-scissors-all-families',
       'castroviejo-scissors',
       'specialty-scissors',
       'power-premium-scissors'
   ]);

   const PFBX_GLOBAL_FACET_KINDS = new Set([
       'price',
       'brand',
       'vendor',
       'availability',
       'tags',
       'categories'
   ]);

   const pfbxGetCollectionHandle = () => {
       const nav = document.getElementById('pfbx-collection-nav-data');
       if (nav) {
           try {
               const data = JSON.parse(nav.textContent || '{}');
               const handle = data?.current?.handle || data?.handle;
               if (handle) return String(handle).toLowerCase().trim();
           } catch (e) {
               /* ignore */
           }
       }
       const m = String(window.location.pathname || '').match(/\/collections\/([^/?#]+)/i);
       return m ? decodeURIComponent(m[1]).toLowerCase().trim() : '';
   };

   const pfbxIsScissorsFilterCollection = () =>
       PFBX_SCISSORS_FILTER_HANDLES.has(pfbxGetCollectionHandle());

   const pfbxFacetKindFromSection = (section) => {
       const cls = String(section.className || '').toLowerCase();
       for (const kind of PFBX_GLOBAL_FACET_KINDS) {
           if (cls.split(/\s+/).includes(kind)) return kind;
       }
       const title = (
           section.querySelector(
               '.prefixbox-filter-group-name, .prefixbox-mobile-filter-group-name, p.prefixbox-filter-group-name'
           )?.textContent || ''
       )
           .replace(/\(\s*[\d,]+\s*\)/g, '')
           .replace(/\s+/g, ' ')
           .trim()
           .toLowerCase();
       if (title === 'price') return 'price';
       if (title === 'vendor' || title === 'brand') return 'vendor';
       if (title.includes('availability')) return 'availability';
       if (title === 'tags') return 'tags';
       if (title === 'categories') return 'categories';
       return 'scissors-specific';
   };

   const pfbxApplyScissorsFacetVisibility = () => {
       const allowScissorsFacets = pfbxIsScissorsFilterCollection();
       document.documentElement.classList.toggle('pfbx-scissors-plp', allowScissorsFacets);
       document.documentElement.classList.toggle('pfbx-hide-scissors-facets', !allowScissorsFacets);
       document.body?.classList.toggle('pfbx-scissors-plp', allowScissorsFacets);
       document.body?.classList.toggle('pfbx-hide-scissors-facets', !allowScissorsFacets);

       const roots = [
           document.querySelector('#left-mode-filters'),
           document.querySelector('#mobile-drawer-filters'),
           document.querySelector('#drawer-mode-filters')
       ].filter(Boolean);

       roots.forEach((root) => {
           root
               .querySelectorAll(
                   '.prefixbox-filter-container, .prefixbox-mobile-filter-container'
               )
               .forEach((section) => {
                   if (
                       section.classList.contains('prefixbox-filter-container-header') ||
                       section.classList.contains('prefixbox-mobile-filter-container-header')
                   ) {
                       return;
                   }
                   const kind = pfbxFacetKindFromSection(section);
                   const keep = allowScissorsFacets || PFBX_GLOBAL_FACET_KINDS.has(kind);
                   section.classList.toggle('pfbx-scissors-facet-hidden', !keep);
                   if (!keep) {
                       section.style.setProperty('display', 'none', 'important');
                   } else if (!section.classList.contains('pfbx-mobile-hide')) {
                       section.style.removeProperty('display');
                   }
               });
       });
   };

   /* Apply ASAP from URL so Length/etc. don't flash on GSI / Surgical pages */
   try {
       pfbxApplyScissorsFacetVisibility();
   } catch (e) {
       /* ignore */
   }
   
   const pfbxBindIWishButtons = () => {
       const buttons = document.querySelectorAll(
           '.pfbx-wishlist-btn .iWishAddColl:not([data-manual-bound="true"])'
       );
   
       buttons.forEach((btn) => {
           btn.setAttribute('data-manual-bound', 'true');
           const variantId = btn.getAttribute('data-variant');
   
           if (pfbxIsInWishlist(variantId)) {
               const svg = btn.querySelector('svg');
               if (svg) svg.innerHTML = HEART_FILLED;
               btn.setAttribute('data-iwish-added', 'true');
           }
   
           btn.addEventListener('click', (e) => {
               e.preventDefault();
               e.stopPropagation();
   
               const productId = btn.getAttribute('data-product');
               const isAdded = btn.getAttribute('data-iwish-added') === 'true';
   
               if (!isAdded) {
                   const existingBound = document.querySelector(
                       '.iWishAddColl[data-manual-bound="true"][data-product="' + productId + '"]:not(.pfbx-wishlist-btn .iWishAddColl)'
                   );
                   if (existingBound) {
                       existingBound.click();
                   } else if (window.iWish && typeof window.iWish.iwishAdd === 'function') {
                       window.iWish.iwishAdd(variantId, productId);
                   } else if (window.iwishAddProxy && typeof window.iwishAddProxy === 'function') {
                       window.iwishAddProxy(variantId, productId);
                   } else {
                       return;
                   }
   
                   const svg = btn.querySelector('svg');
                   if (svg) svg.innerHTML = HEART_FILLED;
                   btn.setAttribute('data-iwish-added', 'true');
               } else {
                   if (window.iWish && typeof window.iWish.iwishRemove === 'function') {
                       window.iWish.iwishRemove(variantId, productId);
                   } else {
                       return;
                   }
   
                   const svg = btn.querySelector('svg');
                   if (svg) svg.innerHTML = HEART_EMPTY;
                   btn.setAttribute('data-iwish-added', 'false');
               }
           });
       });
   };
   
   const pfbxIWishObserver = new MutationObserver(() => {
       const uninitialised = document.querySelectorAll(
           '.pfbx-wishlist-btn .iWishAddColl:not([data-manual-bound="true"])'
       );
       if (uninitialised.length > 0) pfbxBindIWishButtons();
   });
   
   const pfbxFiltersContainer = document.querySelector('#prefixbox-main');
   
   if (pfbxFiltersContainer) {
       pfbxIWishObserver.observe(pfbxFiltersContainer, { childList: true, subtree: true });
   } else {
       document.addEventListener('DOMContentLoaded', () => {
           const container = document.querySelector('#prefixbox-main');
           if (container) pfbxIWishObserver.observe(container, { childList: true, subtree: true });
       });
   }
   
   /* ============================================================
      SKU always on cards
      ============================================================ */
   
   const pfbxSkuCache = {};
   
   const pfbxEnsureSkuOnCards = () => {
       document.querySelectorAll('.prefixbox-product').forEach((card) => {
           const row = card.querySelector('.pfbx-sku-stock-row');
           if (!row || row.querySelector('.pfbx-product-sku')) return;
   
           const link = card.querySelector('.prefixbox-product-name a');
           const href = link?.getAttribute('href') || '';
           const handle = href.split('/products/')[1]?.split(/[?#]/)[0];
           if (!handle) return;
   
           const variantId = card.querySelector('input[name="id"]')?.value;
           const cacheKey = handle + '::' + (variantId || '');
   
           const insertSku = (sku) => {
               if (!sku || row.querySelector('.pfbx-product-sku')) return;
               const el = document.createElement('span');
               el.className = 'pfbx-product-sku';
               el.innerHTML = 'SKU: <strong></strong>';
               el.querySelector('strong').textContent = sku;
               row.insertBefore(el, row.firstChild);
           };
   
           if (pfbxSkuCache[cacheKey]) {
               insertSku(pfbxSkuCache[cacheKey]);
               return;
           }
   
           if (card.getAttribute('data-pfbx-sku-loading') === 'true') return;
           card.setAttribute('data-pfbx-sku-loading', 'true');
   
           fetch('/products/' + handle + '.js')
               .then((res) => (res.ok ? res.json() : null))
               .then((product) => {
                   if (!product || !product.variants) return;
                   const variant =
                       product.variants.find((v) => String(v.id) === String(variantId)) ||
                       product.variants[0];
                   const sku = variant && variant.sku ? String(variant.sku) : '';
                   if (!sku) return;
                   pfbxSkuCache[cacheKey] = sku;
                   insertSku(sku);
               })
               .catch(() => {})
               .finally(() => card.removeAttribute('data-pfbx-sku-loading'));
       });
   };
   
   /* ============================================================
      Helpers — desktop filter roots (never use mobile drawer copies)
      ============================================================ */
   
   /* Phone + tablet (incl. 1024): same Canva drawer/toolbar as mobile */
   const pfbxIsMobileViewport = () => window.matchMedia('(max-width: 1024px)').matches;
   
   const pfbxIsMobileFilterContext = (el) =>
       !!(el && el.closest('#mobile-drawer-filters, #drawer-mode-filters, .prefixbox-mobile-filter-container'));
   
   const pfbxPickDesktopFilter = (selector) => {
       const inLeft = document.querySelector('#left-mode-filters ' + selector);
       if (inLeft) return inLeft;
   
       return (
           [...document.querySelectorAll(selector)].find((el) => !pfbxIsMobileFilterContext(el)) ||
           null
       );
   };
   
   /* ============================================================
      DESKTOP TOGGLES — proven pattern (stay inside Availability / Tags)
      NEVER call drawer.prepend() on these nodes
      ============================================================ */
   
   const pfbxNormalizeAvailabilityLabel = (value) =>
       String(value || '')
           .replace(/\(\s*[\d,]+\s*\)/g, '')
           .replace(/\s+/g, ' ')
           .trim()
           .toLowerCase();

   const pfbxFindInStockCheckbox = (filter) => {
       const availabilityFilter =
           filter || pfbxPickDesktopFilter('.availability.prefixbox-filter-container');
       if (availabilityFilter) {
           const labels = availabilityFilter.querySelectorAll(
               '.prefixbox-filter-text, .prefixbox-mobile-filter-text, label'
           );
           for (const label of labels) {
               const text = pfbxNormalizeAvailabilityLabel(label.textContent);
               if (text !== 'in stock') continue;
               const row = label.closest(
                   '.prefixbox-value-filter-value, .prefixbox-mobile-value-filter-value'
               );
               const box = row?.querySelector('input[type="checkbox"]');
               if (box) return box;
           }
           const first = availabilityFilter.querySelector('input[type="checkbox"]');
           if (first) return first;
       }
       return typeof pfbxFindMobileCheckbox === 'function'
           ? pfbxFindMobileCheckbox('in-stock')
           : null;
   };

   const pfbxAvailabilityFacetHasCheckboxes = (filter) =>
       !!filter?.querySelector(
           '.prefixbox-value-filter-value input[type="checkbox"], .prefixbox-mobile-value-filter-value input[type="checkbox"]'
       );

   const pfbxHideOutOfStockNativeRows = (availabilityFilter) => {
       if (!availabilityFilter) return;
       availabilityFilter
           .querySelectorAll('.prefixbox-value-filter-value, .prefixbox-mobile-value-filter-value')
           .forEach((row) => {
               if (row.querySelector('.pfbx-toggle-wrapper')) return;
               const label = row.querySelector(
                   '.prefixbox-filter-text, .prefixbox-mobile-filter-text, label'
               );
               const text = pfbxNormalizeAvailabilityLabel(label?.textContent);
               if (text === 'out of stock') {
                   row.classList.add('pfbx-hide-oos-row');
                   row.style.setProperty('display', 'none', 'important');
               }
           });
   };

   const pfbxCollapseAvailabilityNativeRows = (availabilityFilter) => {
       if (!availabilityFilter) return;
       pfbxHideOutOfStockNativeRows(availabilityFilter);
       availabilityFilter
           .querySelectorAll('.prefixbox-value-filter-value, .prefixbox-mobile-value-filter-value')
           .forEach((row) => {
               if (row.querySelector('.pfbx-toggle-wrapper')) return;
               row.style.setProperty('display', 'none', 'important');
           });
       const scroller = availabilityFilter.querySelector('[data-virtuoso-scroller="true"]');
       if (scroller) scroller.style.setProperty('height', '0px', 'important');
       availabilityFilter.classList.add('pfbx-availability-ready');
   };

   const pfbxProbeDesktopAvailabilityFacet = (availabilityFilter, done) => {
       if (!availabilityFilter || typeof done !== 'function') return;
       if (pfbxAvailabilityFacetHasCheckboxes(availabilityFilter)) {
           availabilityFilter.classList.add('pfbx-availability-ready');
           done();
           return;
       }

       const optionCount = Number(
           (availabilityFilter.className.match(/prefixbox-filter-count-(\d+)/) || [])[1] || 0
       );
       const scroller = availabilityFilter.querySelector('[data-virtuoso-scroller="true"]');

       pfbxParkDesktopFilterOffscreen(availabilityFilter);
       availabilityFilter
           .querySelectorAll('.prefixbox-value-filter-value, .prefixbox-mobile-value-filter-value')
           .forEach((el) => {
               el.style.removeProperty('display');
           });
       if (scroller && optionCount > 0) {
           scroller.style.setProperty('height', Math.max(optionCount * 36, 36) + 'px', 'important');
       }

       const finish = () => {
           pfbxCollapseAvailabilityNativeRows(availabilityFilter);
           pfbxUnparkDesktopFilterOffscreen(availabilityFilter);
           done();
       };

       if (pfbxAvailabilityFacetHasCheckboxes(availabilityFilter)) {
           finish();
           return;
       }

       setTimeout(() => {
           if (!pfbxAvailabilityFacetHasCheckboxes(availabilityFilter)) {
               setTimeout(finish, 200);
               return;
           }
           finish();
       }, 80);
   };

   const pfbxMountAvailabilityToggle = (availabilityFilter) => {
       if (!availabilityFilter) return;

       pfbxHideOutOfStockNativeRows(availabilityFilter);

       const checkbox = pfbxFindInStockCheckbox(availabilityFilter);
       if (!checkbox) return;

       const existingToggle = availabilityFilter.querySelector(
           '.pfbx-toggle-wrapper[data-pfbx-toggle="in-stock"]'
       );
       const visibleRow = [...availabilityFilter.querySelectorAll('.prefixbox-value-filter-value')].find(
           (row) => row.style.display !== 'none' && !row.querySelector('.pfbx-toggle-wrapper')
       );
       if (existingToggle && !visibleRow) return;
       if (existingToggle && visibleRow) existingToggle.remove();
   
       const values =
           availabilityFilter.querySelector('.prefixbox-filter-values-container-toggleable') ||
           availabilityFilter.querySelector('.prefixbox-mobile-filter-values-container-toggleable');
       if (!values) return;

       if (values.querySelector('.pfbx-toggle-wrapper[data-pfbx-toggle="in-stock"]')) return;
   
       const toggleWrapper = document.createElement('div');
       toggleWrapper.className = 'pfbx-toggle-wrapper';
       toggleWrapper.setAttribute('data-pfbx-toggle', 'in-stock');
       toggleWrapper.innerHTML =
           '<span class="pfbx-toggle-label">In Stock</span>' +
           '<label class="pfbx-toggle-switch"><span class="pfbx-toggle-slider"></span></label>';
   
       const sw = toggleWrapper.querySelector('.pfbx-toggle-switch');
       if (checkbox.checked) sw.classList.add('pfbx-toggle-on');
   
       sw.addEventListener('click', () => {
           const fresh = pfbxFindInStockCheckbox(availabilityFilter);
           if (fresh) fresh.click();
           setTimeout(() => {
               const latest = pfbxFindInStockCheckbox(availabilityFilter);
               if (latest) sw.classList.toggle('pfbx-toggle-on', latest.checked);
           }, 50);
       });
   
       values.appendChild(toggleWrapper);
       pfbxCollapseAvailabilityNativeRows(availabilityFilter);
   };

   const pfbxInitAvailabilityToggle = () => {
       const availabilityFilter = pfbxPickDesktopFilter('.availability.prefixbox-filter-container');
       if (!availabilityFilter) {
           pfbxDesktopToggleBoot.availability = true;
           pfbxMaybeFinishDesktopToggleBoot();
           return;
       }
       pfbxProbeDesktopAvailabilityFacet(availabilityFilter, () => {
           pfbxMountAvailabilityToggle(availabilityFilter);
           pfbxDesktopToggleBoot.availability = true;
           pfbxMaybeFinishDesktopToggleBoot();
       });
   };

   const pfbxPreserveCollectionSubcats = () => {
       document.querySelectorAll('.collection-plp-header, [data-plp-subcats]').forEach((el) => {
           el.style.removeProperty('display');
           el.removeAttribute('hidden');
           el.setAttribute('aria-hidden', 'false');
       });
   };
   
   const pfbxFindTagCheckboxInFilter = (tagsFilter, names) => {
       const wanted = names.map((n) =>
           String(n || '')
               .replace(/\(\s*[\d,]+\s*\)/g, '')
               .replace(/\s+/g, ' ')
               .trim()
               .toLowerCase()
       );
       const labels = tagsFilter.querySelectorAll('.prefixbox-filter-text, .prefixbox-mobile-filter-text');
       for (const label of labels) {
           const text = String(label.textContent || '')
               .replace(/\(\s*[\d,]+\s*\)/g, '')
               .replace(/\s+/g, ' ')
               .trim()
               .toLowerCase();
           if (!wanted.includes(text)) continue;
           return (
               label
                   .closest('.prefixbox-value-filter-value, .prefixbox-mobile-value-filter-value')
                   ?.querySelector('input[type="checkbox"]') || null
           );
       }
       return null;
   };
   
   const pfbxFacetExpectedOptionCount = (filter) =>
       Number((filter?.className.match(/prefixbox-filter-count-(\d+)/) || [])[1] || 0);

   const pfbxFacetMountedCheckboxCount = (filter) =>
       filter?.querySelectorAll(
           '.prefixbox-value-filter-value input[type="checkbox"], .prefixbox-mobile-value-filter-value input[type="checkbox"]'
       ).length || 0;

   const pfbxFacetFullyMounted = (filter) => {
       if (!filter) return false;
       const expected = pfbxFacetExpectedOptionCount(filter);
       const mounted = pfbxFacetMountedCheckboxCount(filter);
       if (expected > 0) return mounted >= expected;
       return mounted > 0;
   };

   /* True only when Prefixbox has this tag option with count > 0 (0 results = hide toggle) */
   const pfbxTagOptionHasResults = (names, tagsFilter) => {
       const wanted = names.map((n) =>
           String(n || '')
               .replace(/\(\s*[\d,]+\s*\)/g, '')
               .replace(/\s+/g, ' ')
               .trim()
               .toLowerCase()
       );

       const scopes = (
           tagsFilter
               ? [tagsFilter]
               : [
                     pfbxPickDesktopFilter('.tags.prefixbox-filter-container'),
                     ...document.querySelectorAll(
                         '.tags.prefixbox-filter-container, .tags.prefixbox-mobile-filter-container'
                     )
                 ]
       ).filter(Boolean);

       let sawExplicitZero = false;

       for (const scope of scopes) {
           const labels = scope.querySelectorAll(
               '.prefixbox-filter-text, .prefixbox-mobile-filter-text'
           );
           for (const label of labels) {
               const raw = String(label.textContent || '')
                   .replace(/\s+/g, ' ')
                   .trim();
               const text = raw
                   .replace(/\(\s*[\d,]+\s*\)/g, '')
                   .replace(/\s+/g, ' ')
                   .trim()
                   .toLowerCase();
               if (!wanted.includes(text)) continue;

               const row = label.closest(
                   '.prefixbox-value-filter-value, .prefixbox-mobile-value-filter-value'
               );
               if (!row) continue;

               const countEl = row.querySelector(
                   '.prefixbox-filter-count, .prefixbox-mobile-filter-count'
               );
               let count = null;
               if (countEl) {
                   const n = parseInt(String(countEl.textContent || '').replace(/[^\d]/g, ''), 10);
                   if (!Number.isNaN(n)) count = n;
               }
               if (count === null) {
                   const m = raw.match(/\(\s*([\d,]+)\s*\)/);
                   if (m) count = parseInt(m[1].replace(/,/g, ''), 10);
               }

               if (count === 0) {
                   sawExplicitZero = true;
                   continue;
               }
               const cb = row.querySelector('input[type="checkbox"]');
               if (cb) return true;
           }
       }

       if (sawExplicitZero) return false;

       const filter =
           tagsFilter || pfbxPickDesktopFilter('.tags.prefixbox-filter-container');
       if (!filter) return false;

       /* Virtuoso may only mount Clearance first — wait before hiding Deals */
       if (!pfbxFacetFullyMounted(filter)) return true;

       return false;
   };

   const pfbxTagsFacetProbed = () => {
       const tags = [
           pfbxPickDesktopFilter('.tags.prefixbox-filter-container'),
           ...document.querySelectorAll(
               '.tags.prefixbox-filter-container, .tags.prefixbox-mobile-filter-container'
           )
       ].filter(Boolean);
       return tags.some(
           (f) =>
               f.querySelector(
                   '.prefixbox-value-filter-value input[type="checkbox"], .prefixbox-mobile-value-filter-value input[type="checkbox"]'
               ) || Number((f.className.match(/prefixbox-filter-count-(\d+)/) || [])[1] || 0) > 0
       );
   };

   /* Mount tag options off-screen so Virtuoso renders rows without sidebar flash */
   const pfbxParkDesktopFilterOffscreen = (filter) => {
       if (!filter) return;
       filter.dataset.pfbxDesktopParked = '1';
       filter.style.setProperty('position', 'fixed', 'important');
       filter.style.setProperty('left', '-12000px', 'important');
       filter.style.setProperty('top', '0', 'important');
       filter.style.setProperty('width', '360px', 'important');
       filter.style.setProperty('height', '480px', 'important');
       filter.style.setProperty('max-height', '480px', 'important');
       filter.style.setProperty('overflow', 'auto', 'important');
       filter.style.setProperty('opacity', '0', 'important');
       filter.style.setProperty('pointer-events', 'none', 'important');
       filter.style.setProperty('visibility', 'visible', 'important');
       filter.style.setProperty('display', 'block', 'important');
       filter.style.setProperty('z-index', '-1', 'important');
   };

   const pfbxUnparkDesktopFilterOffscreen = (filter) => {
       if (!filter || filter.dataset.pfbxDesktopParked !== '1') return;
       delete filter.dataset.pfbxDesktopParked;
       [
           'position',
           'left',
           'top',
           'width',
           'height',
           'max-height',
           'overflow',
           'opacity',
           'pointer-events',
           'visibility',
           'display',
           'z-index'
       ].forEach((prop) => filter.style.removeProperty(prop));
   };

   const pfbxTagsFacetHasCheckboxes = (filter) =>
       !!filter?.querySelector(
           '.prefixbox-value-filter-value input[type="checkbox"], .prefixbox-mobile-value-filter-value input[type="checkbox"]'
       );

   const pfbxProbeDesktopTagsFacet = (tagsFilter, done, attempt = 0) => {
       if (!tagsFilter || typeof done !== 'function') return;
       if (pfbxTagsFacetHasCheckboxes(tagsFilter) && pfbxFacetFullyMounted(tagsFilter)) {
           tagsFilter.classList.add('pfbx-tags-ready');
           done();
           return;
       }

       const optionCount = pfbxFacetExpectedOptionCount(tagsFilter);
       const scroller = tagsFilter.querySelector('[data-virtuoso-scroller="true"]');

       pfbxParkDesktopFilterOffscreen(tagsFilter);
       tagsFilter.querySelectorAll('.prefixbox-value-filter-value, .prefixbox-mobile-value-filter-value').forEach((el) => {
           el.style.removeProperty('display');
       });
       if (scroller && optionCount > 0) {
           scroller.style.setProperty('height', Math.max(optionCount * 36, 36) + 'px', 'important');
       }

       const finish = () => {
           if (
               optionCount > 0 &&
               !pfbxFacetFullyMounted(tagsFilter) &&
               attempt < 8
           ) {
               if (scroller) {
                   scroller.style.setProperty(
                       'height',
                       Math.max(optionCount * 36, 72) + 'px',
                       'important'
                   );
               }
               setTimeout(() => pfbxProbeDesktopTagsFacet(tagsFilter, done, attempt + 1), 120);
               return;
           }

           tagsFilter.querySelectorAll('.prefixbox-value-filter-value, .prefixbox-mobile-value-filter-value').forEach((el) => {
               el.style.setProperty('display', 'none', 'important');
           });
       if (scroller) scroller.style.setProperty('height', '0px', 'important');
           pfbxUnparkDesktopFilterOffscreen(tagsFilter);
           tagsFilter.classList.add('pfbx-tags-ready');
           done();
       };

       if (pfbxTagsFacetHasCheckboxes(tagsFilter) && pfbxFacetFullyMounted(tagsFilter)) {
           finish();
           return;
       }

       setTimeout(() => {
           if (!pfbxTagsFacetHasCheckboxes(tagsFilter)) {
               setTimeout(finish, 200);
               return;
           }
           finish();
       }, 80);
   };

   const pfbxReconcileDesktopTagToggles = (tagsFilter, availabilityFilter) => {
       const avail =
           availabilityFilter ||
           pfbxPickDesktopFilter('.availability.prefixbox-filter-container');

       /* No Tags facet at all → In Stock owns the separator above Price */
       if (!tagsFilter) {
           avail?.classList.add('pfbx-toggles-last');
           return;
       }

       const wrap = tagsFilter.querySelector('.pfbx-tags-toggles');
       if (!wrap) {
           tagsFilter.classList.add('pfbx-tags-empty');
           avail?.classList.add('pfbx-toggles-last');
           return;
       }

       const specs = [
           { key: 'deals', names: ['Deals', 'Deal'] },
           { key: 'sale', names: ['Clearance', 'Sale', 'Clearence'] }
       ];

       let anyVisible = false;
       specs.forEach(({ key, names }) => {
           const row = wrap.querySelector(`[data-pfbx-toggle="${key}"]`);
           if (!row) return;
           const available = pfbxTagOptionHasResults(names, tagsFilter);
           const show = available;
           row.style.setProperty('display', show ? 'flex' : 'none', 'important');
           if (show) {
               anyVisible = true;
               const sw = row.querySelector('.pfbx-toggle-switch');
               const cb =
                   pfbxFindTagCheckboxInFilter(tagsFilter, names) ||
                   (typeof pfbxFindMobileCheckbox === 'function' ? pfbxFindMobileCheckbox(key) : null);
               if (sw && cb) sw.classList.toggle('pfbx-toggle-on', !!cb.checked);
           }
       });

       if (anyVisible) {
           tagsFilter.classList.remove('pfbx-tags-empty');
           avail?.classList.remove('pfbx-toggles-last');
           wrap.style.setProperty('display', 'flex', 'important');
       } else {
           /* No Deals/Sale (0 results or missing) — Availability keeps bottom border */
           tagsFilter.classList.add('pfbx-tags-empty');
           avail?.classList.add('pfbx-toggles-last');
           wrap.style.setProperty('display', 'none', 'important');
       }
   };

   let pfbxDesktopToggleBoot = { availability: false, tags: false };

   const pfbxMaybeFinishDesktopToggleBoot = () => {
       const tagsFilter = pfbxPickDesktopFilter('.tags.prefixbox-filter-container');
       const tagsDone = pfbxDesktopToggleBoot.tags || !tagsFilter;
       if (!pfbxDesktopToggleBoot.availability || !tagsDone) return;
       if (typeof pfbxEnsureInStockDefault === 'function') pfbxEnsureInStockDefault();
       if (typeof pfbxExpandDesktopFacetScrollers === 'function') pfbxExpandDesktopFacetScrollers();
   };

   const pfbxReconcileDesktopTagTogglesUntilReady = (tagsFilter, availabilityFilter, attempt = 0) => {
       if (!tagsFilter) {
           pfbxDesktopToggleBoot.tags = true;
           pfbxMaybeFinishDesktopToggleBoot();
           return;
       }

       pfbxReconcileDesktopTagToggles(tagsFilter, availabilityFilter);

       const wrap = tagsFilter.querySelector('.pfbx-tags-toggles');
       const dealsRow = wrap?.querySelector('[data-pfbx-toggle="deals"]');
       const dealsVisible = dealsRow && dealsRow.style.display !== 'none';
       const dealsShouldShow = pfbxTagOptionHasResults(['Deals', 'Deal'], tagsFilter);
       const stillMounting = !pfbxFacetFullyMounted(tagsFilter);

       if (attempt < 25 && (stillMounting || (dealsShouldShow && !dealsVisible))) {
           setTimeout(() => {
               if (stillMounting && attempt > 0 && attempt % 5 === 4) {
                   tagsFilter.classList.remove('pfbx-tags-ready');
                   pfbxProbeDesktopTagsFacet(tagsFilter, () => {
                       pfbxReconcileDesktopTagTogglesUntilReady(
                           tagsFilter,
                           availabilityFilter,
                           attempt + 1
                       );
                   });
                   return;
               }
               pfbxReconcileDesktopTagTogglesUntilReady(
                   tagsFilter,
                   availabilityFilter,
                   attempt + 1
               );
           }, 120);
           return;
       }

       pfbxDesktopToggleBoot.tags = true;
       pfbxMaybeFinishDesktopToggleBoot();
   };
   
   const pfbxInitTagToggles = () => {
       const availabilityFilter = pfbxPickDesktopFilter('.availability.prefixbox-filter-container');
       const tagsFilter = pfbxPickDesktopFilter('.tags.prefixbox-filter-container');
       if (!tagsFilter) {
           availabilityFilter?.classList.add('pfbx-toggles-last');
           pfbxDesktopToggleBoot.tags = true;
           pfbxMaybeFinishDesktopToggleBoot();
           return;
       }
       if (availabilityFilter && availabilityFilter.parentNode === tagsFilter.parentNode) {
           if (availabilityFilter.nextElementSibling !== tagsFilter) {
               availabilityFilter.insertAdjacentElement('afterend', tagsFilter);
           }
       }
   
       const groupName = tagsFilter.querySelector(
           '.prefixbox-filter-group-name, .prefixbox-mobile-filter-group-name'
       );
       if (groupName) groupName.style.display = 'none';
   
       const scroller = tagsFilter.querySelector('[data-virtuoso-scroller="true"]');
   
       let togglesWrapper = tagsFilter.querySelector('.pfbx-tags-toggles');
       if (!togglesWrapper) {
       const values =
           tagsFilter.querySelector('.prefixbox-filter-values-container-toggleable') ||
               tagsFilter.querySelector('.prefixbox-mobile-filter-values-container-toggleable') ||
               (() => {
                   const host = document.createElement('div');
                   host.className = 'prefixbox-filter-values-container-toggleable';
                   tagsFilter.appendChild(host);
                   return host;
               })();

           togglesWrapper = document.createElement('div');
       togglesWrapper.className = 'pfbx-tags-toggles';
   
           const makeTagToggle = (key, label, names) => {
               const findCb = () =>
                   pfbxFindTagCheckboxInFilter(tagsFilter, names) ||
                   (typeof pfbxFindMobileCheckbox === 'function' ? pfbxFindMobileCheckbox(key) : null);

           const row = document.createElement('div');
           row.className = 'pfbx-toggle-wrapper';
           row.setAttribute('data-pfbx-toggle', key);
               row.style.setProperty('display', 'none', 'important');
           row.innerHTML =
               '<span class="pfbx-toggle-label">' +
               label +
               '</span><label class="pfbx-toggle-switch"><span class="pfbx-toggle-slider"></span></label>';
   
           const sw = row.querySelector('.pfbx-toggle-switch');
           sw.addEventListener('click', () => {
               const fresh = findCb();
                   if (!fresh) return;
                   fresh.click();
               setTimeout(() => {
                   const latest = findCb();
                   if (latest) sw.classList.toggle('pfbx-toggle-on', latest.checked);
               }, 50);
           });
   
           return row;
       };
   
           togglesWrapper.appendChild(makeTagToggle('deals', 'Deals', ['Deals', 'Deal']));
       togglesWrapper.appendChild(
               makeTagToggle('sale', 'Clearance', ['Clearance', 'Sale', 'Clearence'])
           );
       values.appendChild(togglesWrapper);
       }

       const finishTagToggles = () => {
           pfbxReconcileDesktopTagTogglesUntilReady(tagsFilter, availabilityFilter, 0);
           if (typeof pfbxSyncSaleToggleLabels === 'function') pfbxSyncSaleToggleLabels();
           if (scroller) scroller.style.setProperty('height', '0px', 'important');
       };

       pfbxProbeDesktopTagsFacet(tagsFilter, finishTagToggles);
   };
   
   /* Remove leftover .pfbx-quick-toggles that older broken scripts moved into drawers */
   const pfbxRemoveStolenQuickToggles = () => {
       document.querySelectorAll('.pfbx-quick-toggles').forEach((el) => {
           // Desktop no longer uses this container — remove orphans from drawers / sidebar
           el.remove();
       });
   };
   
   const pfbxBuildDesktopToggles = () => {
       pfbxRemoveStolenQuickToggles();
       pfbxDesktopToggleBoot = { availability: false, tags: false };
       pfbxInitAvailabilityToggle();
       pfbxInitTagToggles();
   };

   /* ============================================================
      Desktop facets — no inner scrollbars (expand/collapse kept)
      Length, Application, Cutting Edge, Tip Style, Coating, Blade Shape
      Dynamically fit Virtuoso height to REAL option rows (no static
      36px estimate → removes bottom white space). Runs for every
      matching open facet on every category level.
      ============================================================ */

   const PFBX_NO_SCROLL_FACET_TITLES = [
       'length',
       'application',
       'cutting edge',
       'tip style',
       'coating',
       'blade shape'
   ];

   const pfbxNormalizeFacetTitle = (value) =>
       String(value || '')
           .replace(/\(\s*[\d,]+\s*\)/g, '')
           .replace(/\s+/g, ' ')
           .trim()
           .toLowerCase();

   const pfbxIsNoScrollDesktopFacet = (section) => {
       if (!section || !section.classList.contains('prefixbox-filter-container')) return false;
       // Never touch Price / Vendor / Availability / Tags / Categories
       if (
           section.classList.contains('price') ||
           section.classList.contains('brand') ||
           section.classList.contains('vendor') ||
           section.classList.contains('availability') ||
           section.classList.contains('tags') ||
           section.classList.contains('categories')
       ) {
           return false;
       }
       if (section.classList.contains('pfbx-no-scroll-facet')) return true;

       const titleEl = section.querySelector(
           '.prefixbox-filter-group-name, .prefixbox-mobile-filter-group-name, p.prefixbox-filter-group-name'
       );
       const title = pfbxNormalizeFacetTitle(titleEl?.textContent);
       return PFBX_NO_SCROLL_FACET_TITLES.some(
           (wanted) => title === wanted || title.startsWith(wanted + ' ')
       );
   };

   const pfbxIsDesktopFacetOpen = (section) => {
       if (section.classList.contains('prefixbox-open')) return true;
       const btn =
           section.querySelector('[role="button"]') ||
           section.querySelector('.prefixbox-filter-group-name, .prefixbox-mobile-filter-group-name');
       return btn?.getAttribute('aria-expanded') === 'true';
   };

   const pfbxGetFacetScrollers = (section) =>
       section.querySelectorAll(
           '[data-virtuoso-scroller="true"], [data-testid="virtuoso-scroller"], [data-test-id="virtuoso-scroller"]'
       );

   const pfbxGetFacetRows = (section) =>
       [...section.querySelectorAll('.prefixbox-value-filter-value, .prefixbox-mobile-value-filter-value')];

   const pfbxGetFacetOptionCount = (section) => {
       const countFromClass = Number(
           (section.className.match(/prefixbox-filter-count-(\d+)/) || [])[1] || 0
       );
       return Math.max(countFromClass, pfbxGetFacetRows(section).length, 1);
   };

   /* Tight height from real DOM — never keep a too-tall static guess */
   const pfbxMeasureFacetContentHeight = (section) => {
       const rows = pfbxGetFacetRows(section);
       const count = pfbxGetFacetOptionCount(section);
       if (!rows.length) return Math.max(count * 28, 28);

       const first = rows[0];
       const last = rows[rows.length - 1];
       const rowH = Math.max(Math.round(first.getBoundingClientRect().height), 1);
       const exact = Math.ceil(
           last.getBoundingClientRect().bottom - first.getBoundingClientRect().top
       );

       // Virtuoso may not have painted every row yet
       if (rows.length < count) return Math.ceil(count * rowH);

       // Prefer exact span only — this removes the bottom white gap
       return Math.max(exact, rowH);
   };

   const pfbxApplyFacetScrollerHeight = (section, height) => {
       const h = Math.max(Math.ceil(height), 1);

       pfbxGetFacetScrollers(section).forEach((scroller) => {
           scroller.style.setProperty('height', h + 'px', 'important');
           scroller.style.setProperty('max-height', 'none', 'important');
           scroller.style.setProperty('min-height', '0', 'important');
           scroller.style.setProperty('overflow', 'hidden', 'important');
           scroller.style.setProperty('overflow-y', 'hidden', 'important');
           scroller.style.setProperty('overflow-x', 'hidden', 'important');
       });

       section
           .querySelectorAll(
               '.prefixbox-value-filter-values, .prefixbox-mobile-value-filter-values, [data-viewport-type="element"]'
           )
           .forEach((el) => {
               el.style.setProperty('height', 'auto', 'important');
               el.style.setProperty('max-height', 'none', 'important');
               el.style.setProperty('overflow', 'hidden', 'important');
               el.style.setProperty('overflow-y', 'hidden', 'important');
           });

       const values = section.querySelector(
           '.prefixbox-filter-values-container-toggleable, .prefixbox-mobile-filter-values-container-toggleable'
       );
       if (values) {
           values.style.setProperty('max-height', 'none', 'important');
           values.style.setProperty('overflow', 'visible', 'important');
           values.style.setProperty('height', 'auto', 'important');
       }
   };

   const pfbxFitOneDesktopFacet = (section) => {
       if (!section || !pfbxIsNoScrollDesktopFacet(section)) return;
       section.classList.add('pfbx-no-scroll-facet');
       if (!pfbxIsDesktopFacetOpen(section)) return;

       // Pass 1: provisional height so Virtuoso can mount all options
       const count = pfbxGetFacetOptionCount(section);
       const rows = pfbxGetFacetRows(section);
       const sampleH = rows[0]
           ? Math.max(Math.round(rows[0].getBoundingClientRect().height), 1)
           : 28;
       pfbxApplyFacetScrollerHeight(section, count * sampleH);

       // Pass 2+: shrink to measured content (dynamic for every facet)
       const tighten = () => {
           if (!pfbxIsDesktopFacetOpen(section)) return;
           pfbxApplyFacetScrollerHeight(section, pfbxMeasureFacetContentHeight(section));
       };
       requestAnimationFrame(() => {
           tighten();
           setTimeout(tighten, 50);
           setTimeout(tighten, 160);
           setTimeout(tighten, 320);
       });
   };

   const pfbxExpandDesktopFacetScrollers = () => {
       const root = document.querySelector('#left-mode-filters');
       if (!root) return;

       root.querySelectorAll('.prefixbox-filter-container').forEach((section) => {
           if (!pfbxIsNoScrollDesktopFacet(section)) return;
           section.classList.add('pfbx-no-scroll-facet');
           pfbxFitOneDesktopFacet(section);
       });
   };

   const pfbxSyncSaleToggleLabels = () => {
       document.querySelectorAll('[data-pfbx-toggle="sale"] .pfbx-toggle-label').forEach((el) => {
           if (el.textContent.trim() !== 'Clearance') el.textContent = 'Clearance';
       });
   };
   
   /* ============================================================
      SELECTED FILTERS — show Clearance label + sync toggle UI
      ============================================================ */
   
   const pfbxRenameSelectedFilters = () => {
       const selectedFilters = document.querySelectorAll('.prefixbox-selected-filter-value-filter-value');

       selectedFilters.forEach((filter) => {
           if (filter.textContent.trim() === 'Sale') filter.textContent = 'Clearance';
       });

       pfbxSyncSaleToggleLabels();

       const active = Array.from(selectedFilters).map((f) => f.textContent.trim());

       document
           .querySelectorAll(
               '.availability.prefixbox-filter-container [data-pfbx-toggle="in-stock"] .pfbx-toggle-switch, .pfbx-mobile-drawer-toggles [data-pfbx-toggle="in-stock"] .pfbx-toggle-switch'
           )
           .forEach((sw) =>
               sw.classList.toggle(
                   'pfbx-toggle-on',
                   active.some((t) => String(t).toLowerCase() === 'in stock')
               )
           );

       document
           .querySelectorAll(
               '.pfbx-tags-toggles [data-pfbx-toggle="sale"] .pfbx-toggle-switch, .pfbx-mobile-drawer-toggles [data-pfbx-toggle="sale"] .pfbx-toggle-switch'
           )
           .forEach((sw) =>
               sw.classList.toggle(
                   'pfbx-toggle-on',
                   active.includes('Clearance') || active.includes('Sale')
               )
           );

       document
           .querySelectorAll(
               '.pfbx-tags-toggles [data-pfbx-toggle="deals"] .pfbx-toggle-switch, .pfbx-mobile-drawer-toggles [data-pfbx-toggle="deals"] .pfbx-toggle-switch'
           )
           .forEach((sw) => sw.classList.toggle('pfbx-toggle-on', active.includes('Deals')));

       // As soon as a filter is applied, kill the drawer top strip (count / Clear all)
       if (pfbxIsMobileViewport()) {
           const drawer = document.querySelector('#mobile-drawer-filters');
           if (drawer) pfbxHideDrawerSelectedStrip(drawer);
       }
   };
   
   if (pfbxFiltersContainer) {
       new MutationObserver(() => pfbxRenameSelectedFilters()).observe(pfbxFiltersContainer, {
           childList: true,
           subtree: true
       });
   }
   
   
/* ============================================================
   CATEGORIES — Collection Metafield nav (Joey inject approach)
   Data: #pfbx-collection-nav-data from theme (custom.subcategory)
   ============================================================ */

const pfbxReadCollectionNavData = () => {
  const el = document.getElementById('pfbx-collection-nav-data');
  if (!el) return null;
  try {
    return JSON.parse(el.textContent || '');
  } catch (e) {
    return null;
  }
};

const pfbxEscapeHtml = (value) => {
  const el = document.createElement('div');
  el.textContent = String(value == null ? '' : value);
  return el.innerHTML;
};

const pfbxBuildMetafieldCategoriesMarkup = (data) => {
  if (!data || !data.current) return '';

  const children = Array.isArray(data.children) ? data.children : [];
  const siblings = Array.isArray(data.siblings) ? data.siblings : [];
  const useChildren = children.length > 0;
  const links = useChildren ? children : siblings;

  // Canva: full ancestor trail — SVG left chevron + parent title
  let ancestors = Array.isArray(data.ancestors) ? data.ancestors.filter(Boolean) : [];
  if (!ancestors.length && data.parent && data.parent.url && data.parent.title) {
    ancestors = [data.parent];
  }

  const chevronSvg =
    '<span class="pfbx-metafield-categories__chevron" aria-hidden="true">' +
    '<svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M7 1L2 6L7 11" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg></span>';

  let html = '';
  html += '<p class="pfbx-metafield-categories__title">Categories</p>';
  html += '<ul class="pfbx-metafield-categories__list">';

  ancestors.forEach((anc) => {
    if (!anc || !anc.url || !anc.title) return;
    html +=
      '<li class="pfbx-metafield-categories__item pfbx-metafield-categories__item--ancestor">' +
      '<a class="pfbx-metafield-categories__link" href="' +
      pfbxEscapeHtml(anc.url) +
      '">' +
      chevronSvg +
      '<span class="pfbx-metafield-categories__ancestor-label">' +
      pfbxEscapeHtml(anc.title) +
      '</span></a></li>';
  });

  if (useChildren) {
    /* Parent collection (e.g. Scissors): current bar, then children under it */
  html +=
    '<li class="pfbx-metafield-categories__item pfbx-metafield-categories__item--current">' +
    '<span class="pfbx-metafield-categories__current">' +
    pfbxEscapeHtml(data.current.title) +
    '</span></li>';

  links.forEach((item) => {
    if (!item || !item.url || !item.title) return;
      html +=
        '<li class="pfbx-metafield-categories__item pfbx-metafield-categories__item--child">' +
        '<a class="pfbx-metafield-categories__link" href="' +
        pfbxEscapeHtml(item.url) +
        '">' +
        pfbxEscapeHtml(item.title) +
        '</a></li>';
    });
  } else {
    /*
      Leaf collection (e.g. Dean Scissors): keep sibling order fixed.
      Selected item stays in its original place (after Kelly, etc.) — never jump to top.
    */
    let currentRendered = false;
    links.forEach((item) => {
      if (!item || !item.title) return;
      const isCurrent =
        (item.handle && data.current.handle && item.handle === data.current.handle) ||
        (item.title && data.current.title && item.title === data.current.title);

      if (isCurrent) {
        currentRendered = true;
        html +=
          '<li class="pfbx-metafield-categories__item pfbx-metafield-categories__item--sibling pfbx-metafield-categories__item--active" aria-current="page">' +
          '<span class="pfbx-metafield-categories__link">' +
          pfbxEscapeHtml(data.current.title || item.title) +
          '</span></li>';
      return;
    }

      if (!item.url) return;
    html +=
        '<li class="pfbx-metafield-categories__item pfbx-metafield-categories__item--sibling">' +
      '<a class="pfbx-metafield-categories__link" href="' +
      pfbxEscapeHtml(item.url) +
      '">' +
      pfbxEscapeHtml(item.title) +
      '</a></li>';
  });

    /* Fallback if current is missing from sibling metafield list */
    if (!currentRendered && data.current.title) {
      html +=
        '<li class="pfbx-metafield-categories__item pfbx-metafield-categories__item--sibling pfbx-metafield-categories__item--active" aria-current="page">' +
        '<span class="pfbx-metafield-categories__link">' +
        pfbxEscapeHtml(data.current.title) +
        '</span></li>';
    }
  }

  html += '</ul>';
  return html;
};

const pfbxHideNativeCategoriesFilter = (root) => {
  const scope = root || document;
  scope
    .querySelectorAll(
      '.categories.prefixbox-filter-container, .categories.prefixbox-mobile-filter-container'
    )
    .forEach((el) => {
      el.classList.add('pfbx-native-categories-hidden');
      el.style.setProperty('display', 'none', 'important');
    });
};

/* Canva: hide only known "Filters" chrome — never scan all text nodes (breaks remounts) */
const pfbxHideDesktopFiltersLabel = () => {
  const left = document.querySelector('#left-mode-filters');
  if (!left) return;

  left
    .querySelectorAll(
      ':scope > .prefixbox-filter-container-header, .pfbx-metafield-categories__filters-label, [data-pfbx-filters-label="1"]'
    )
    .forEach((el) => {
      el.classList.add('pfbx-hide-filters-label');
      el.style.setProperty('display', 'none', 'important');
      el.setAttribute('aria-hidden', 'true');
    });
};

const pfbxInjectMetafieldCategories = () => {
  try {
    pfbxHideNativeCategoriesFilter(document);
    pfbxHideDesktopFiltersLabel();

    const left = document.querySelector('#left-mode-filters');
    if (!left) return;

    const data = pfbxReadCollectionNavData();
    if (!data || !data.current) return;

    const markup = pfbxBuildMetafieldCategoriesMarkup(data);
    if (!markup) return;

    // Prefixbox remounts wipe our node — always re-find / recreate
    let nav = left.querySelector('.pfbx-metafield-categories');
    if (nav && nav.parentElement !== left) {
      nav.remove();
      nav = null;
    }
    if (!nav) {
      nav = document.createElement('div');
      nav.className = 'pfbx-metafield-categories';
      nav.setAttribute('data-pfbx-metafield-categories', '1');
    }

    const firstFilter = left.querySelector(
      ':scope > .prefixbox-filter-container, :scope > .availability, :scope > .tags, :scope > .price, .prefixbox-filter-container, .availability.prefixbox-filter-container'
    );
    if (firstFilter && firstFilter.parentElement === left) {
      left.insertBefore(nav, firstFilter);
    } else if (nav.parentElement !== left) {
      left.prepend(nav);
    }

    const fingerprint = JSON.stringify({
      c: data.current && data.current.handle,
      a: (data.ancestors || []).map((x) => x && x.handle),
      p: data.parent && data.parent.handle,
      ch: (data.children || []).map((x) => x && x.handle),
      s: (data.siblings || []).map((x) => x && x.handle)
    });

    if (nav.getAttribute('data-pfbx-nav-fp') === fingerprint && nav.innerHTML) return;
    nav.setAttribute('data-pfbx-nav-fp', fingerprint);
    nav.innerHTML = markup;
  } catch (err) {
    /* never block toggles / other sidebar work */
  }
};


/* ============================================================
      CATEGORIES — chips + highlight (desktop)
      ============================================================ */
   
   const pfbxNormalizeLabel = (value) =>
       String(value || '')
           .toLowerCase()
           .replace(/&/g, 'and')
           .replace(/[^a-z0-9]+/g, ' ')
           .trim();
   
   const pfbxGetCurrentCollectionTitle = () => {
       const titleEl = document.querySelector('.collection-plp-header__title');
       if (titleEl && titleEl.textContent.trim()) return titleEl.textContent.trim();
       const match = window.location.pathname.match(/\/collections\/([^/?#]+)/i);
       if (!match) return '';
       return decodeURIComponent(match[1]).replace(/-/g, ' ');
   };
   
   const pfbxRemoveLegacyCanvaNav = () => {
       document.querySelectorAll('.pfbx-canva-categories').forEach((el) => el.remove());
   };
   
   const pfbxCleanCategoryChips = () => {
       const skip = new Set(['home', 'products', 'all']);
       const categoryLabels = new Set([pfbxNormalizeLabel(pfbxGetCurrentCollectionTitle())]);
   
       document
           .querySelectorAll(
               '.categories.prefixbox-filter-container .prefixbox-filter-text, .categories.prefixbox-filter-container .prefixbox-mobile-filter-text'
           )
           .forEach((el) => {
               const text = pfbxNormalizeLabel(el.textContent);
               if (text) categoryLabels.add(text);
           });
   
       document.querySelectorAll('.collection-plp-breadcrumbs a, .collection-plp-breadcrumbs__current').forEach((el) => {
           const text = pfbxNormalizeLabel(el.textContent);
           if (text && !skip.has(text)) categoryLabels.add(text);
       });
   
       document
           .querySelectorAll(
               '.prefixbox-selected-filter-value-filter-value, .prefixbox-selected-filter, [class*="selected-filter-value"]'
           )
           .forEach((chip) => {
               const raw = chip.textContent || '';
               const text = pfbxNormalizeLabel(raw);
               const isCategoryChip =
                   /categories\s*:/i.test(raw) ||
                   categoryLabels.has(text) ||
                   [...categoryLabels].some((label) => label && text.includes(label));
   
               if (isCategoryChip) {
                   chip.classList.add('pfbx-category-chip');
                   const wrap = chip.closest('[class*="selected-filter"]') || chip.parentElement;
                   if (wrap && wrap !== chip) wrap.classList.add('pfbx-category-chip');
               }
           });
   };
   
   const pfbxHighlightCurrentCategory = () => {
       const currentTitle = pfbxNormalizeLabel(pfbxGetCurrentCollectionTitle());
       if (!currentTitle) return;
   
       document.querySelectorAll('.pfbx-category-active, .pfbx-category-active-label').forEach((el) => {
           el.classList.remove('pfbx-category-active', 'pfbx-category-active-label');
       });
   
       const rows = Array.from(
           document.querySelectorAll(
               '.categories.prefixbox-filter-container .prefixbox-value-filter-value,' +
                   '.categories.prefixbox-filter-container .prefixbox-mobile-value-filter-value'
           )
       );
   
       const getRowText = (row) => {
           const textEl = row.querySelector('.prefixbox-filter-text, .prefixbox-mobile-filter-text');
           const raw = textEl
               ? textEl.textContent
               : String(row.querySelector('label')?.textContent || '').replace(/\(\s*\d+\s*\)/g, '');
           return pfbxNormalizeLabel(raw);
       };
   
       let matched = rows.filter((row) => getRowText(row) === currentTitle);
       if (!matched.length) {
           matched = rows
               .filter((row) => {
                   const text = getRowText(row);
                   return text && text.includes(currentTitle);
               })
               .sort((a, b) => getRowText(a).length - getRowText(b).length)
               .slice(0, 1);
       }
   
       matched.forEach((row) => {
           row.classList.add('pfbx-category-active');
           const labelEl = row.querySelector('label');
           if (labelEl) labelEl.classList.add('pfbx-category-active-label');
       });
   };
   
   const pfbxInitPricePlaceholders = () => {
       const inputPairs = document.querySelectorAll(
           '.prefixbox-range-filter-with-input-inputs, .prefixbox-mobile-range-filter-with-input-inputs'
       );
       inputPairs.forEach((pair) => {
           const minInput = pair.querySelector('.min-input input');
           const maxInput = pair.querySelector('.max-input input');
           if (!minInput || !maxInput) return;

           minInput.setAttribute('placeholder', 'From');
           maxInput.setAttribute('placeholder', 'To');

           const scope =
               pair.closest(
                   '.price.prefixbox-mobile-filter-container, .price.prefixbox-filter-container'
               ) || document;
           const slider =
               scope.querySelector(
                   '.prefixbox-mobile-range-filter-with-input-values .noUi-target, .prefixbox-range-filter-with-input-values .noUi-target, .noUi-target'
               ) || null;
           if (!slider) return;

           const minHandle = slider.querySelector('.noUi-handle-lower');
           const maxHandle = slider.querySelector('.noUi-handle-upper');

           if (minHandle && minInput.value === minHandle.getAttribute('aria-valuemin')?.replace('.0', '')) {
               minInput.value = '';
           }
           if (maxHandle && maxInput.value === maxHandle.getAttribute('aria-valuemax')?.replace('.0', '')) {
               maxInput.value = '';
           }
       });
       if (typeof pfbxLockAllPriceSections === 'function') pfbxLockAllPriceSections();
   };
   
   /* ============================================================
      Sort / Show options
      ============================================================ */
   
   const pfbxDesiredSortOptions = [
       'Best Sellers',
       'Price: High to Low',
       'Price: Low to High',
       'Alphabetically: A–Z',
       'Alphabetically: Z–A'
   ];
   const pfbxDesiredShowOptions = ['24', '48', '96'];
   
   const pfbxNormalizeOptionText = (text) =>
       String(text || '')
           .replace(/\s+/g, ' ')
           .replace(/[–—]/g, '-')
           .trim()
           .toLowerCase();
   
   const pfbxSyncSelectOptions = (select, desiredOptions) => {
       if (!select || !desiredOptions || !desiredOptions.length) return;
   
       const existing = Array.from(select.options);
       const selectedTextBefore = (select.options[select.selectedIndex]?.textContent || '').trim();
   
       const mapped = desiredOptions
           .map((desiredLabel) => {
               const desiredNorm = pfbxNormalizeOptionText(desiredLabel);
               const match =
                   existing.find((opt) => pfbxNormalizeOptionText(opt.textContent) === desiredNorm) ||
                   existing.find((opt) => pfbxNormalizeOptionText(opt.value) === desiredNorm);
               return match ? { value: match.value, label: desiredLabel } : null;
           })
           .filter(Boolean);
   
       if (!mapped.length) return;
   
       select.innerHTML = '';
       mapped.forEach((item) => {
           const option = document.createElement('option');
           option.value = item.value;
           option.textContent = item.label;
           select.appendChild(option);
       });
   
       const selectedNorm = pfbxNormalizeOptionText(selectedTextBefore);
       const keepSelected = Array.from(select.options).find(
           (opt) => pfbxNormalizeOptionText(opt.textContent) === selectedNorm
       );
       const pageNumber = new URLSearchParams(window.location.search).get('pf-page');
   
       if (keepSelected && select.value !== keepSelected.value && !pageNumber) {
           select.value = keepSelected.value;
           select.dispatchEvent(new Event('change', { bubbles: true }));
       }
   };
   
   const pfbxSyncSortShowOptions = () => {
       document.querySelectorAll('select.prefixbox-dropdown, #pfbx-result-informations select').forEach((select) => {
           const contextText = pfbxNormalizeOptionText(
               select.closest('#sort-direction, #page-size, .sort, .show')?.textContent || ''
           );
           const hasNumericOptions = Array.from(select.options).some((opt) =>
               /^\d+$/.test((opt.textContent || '').trim())
           );
           if (contextText.includes('show') || hasNumericOptions) {
               pfbxSyncSelectOptions(select, pfbxDesiredShowOptions);
           } else {
               pfbxSyncSelectOptions(select, pfbxDesiredSortOptions);
           }
       });
   };

   /* ============================================================
      Canva pages 12–13 — mobile toolbar
      Left: Best sellers (no Sort by label)
      Right: Filters
      Hide: product count + Show
      ============================================================ */

   /* Prefixbox puts "Sort by" in .prefixbox-dropdown-displaytext — show selected value instead.
      Native <select> open menus can't match Canva — use a custom panel that syncs the real select. */
   const pfbxCloseMobileSortMenus = (except) => {
       document.querySelectorAll('#sort-direction.pfbx-sort-open').forEach((el) => {
           if (except && el === except) return;
           el.classList.remove('pfbx-sort-open');
           const menu = el.querySelector('.pfbx-sort-menu');
           if (menu) menu.hidden = true;
       });
   };

   const pfbxBuildMobileSortMenu = (sort, select) => {
       let menu = sort.querySelector('.pfbx-sort-menu');
       if (!menu) {
           menu = document.createElement('div');
           menu.className = 'pfbx-sort-menu';
           menu.setAttribute('role', 'listbox');
           menu.hidden = true;
           sort.appendChild(menu);
       }

       const options = Array.from(select.options || []);
       const selectedValue = select.value;
       menu.innerHTML = '';

       options.forEach((opt) => {
           const btn = document.createElement('button');
           btn.type = 'button';
           btn.className = 'pfbx-sort-option';
           btn.setAttribute('role', 'option');
           btn.dataset.value = opt.value;
           btn.textContent = String(opt.textContent || '').replace(/\s+/g, ' ').trim();
           if (opt.value === selectedValue || opt.selected) {
               btn.classList.add('is-selected');
               btn.setAttribute('aria-selected', 'true');
           } else {
               btn.setAttribute('aria-selected', 'false');
           }
           btn.addEventListener('click', (e) => {
               e.preventDefault();
               e.stopPropagation();
               if (select.value !== opt.value) {
                   select.value = opt.value;
                   select.dispatchEvent(new Event('change', { bubbles: true }));
                   select.dispatchEvent(new Event('input', { bubbles: true }));
               }
               pfbxSyncMobileSortDisplay(sort);
               pfbxCloseMobileSortMenus();
           });
           menu.appendChild(btn);
       });

       return menu;
   };

   const pfbxToggleMobileSortMenu = (sort, forceOpen) => {
       if (!sort || !pfbxIsMobileViewport()) return;
       const select = sort.querySelector('select.prefixbox-dropdown');
       if (!select) return;

       const willOpen =
           typeof forceOpen === 'boolean' ? forceOpen : !sort.classList.contains('pfbx-sort-open');

       pfbxCloseMobileSortMenus(willOpen ? sort : null);
       sort.classList.toggle('pfbx-sort-open', willOpen);

       const display = sort.querySelector('.prefixbox-dropdown-displaytext');
       if (display) display.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

       const menu = pfbxBuildMobileSortMenu(sort, select);
       menu.hidden = !willOpen;
   };

   const pfbxSyncMobileSortDisplay = (sort) => {
       if (!sort) return;
       const select = sort.querySelector('select.prefixbox-dropdown');
       let display = sort.querySelector('.prefixbox-dropdown-displaytext');
       if (!select) return;

       if (!display) {
           display = document.createElement('div');
           display.className = 'prefixbox-dropdown-displaytext';
           sort.insertBefore(display, select);
       }

       const opt = select.options[select.selectedIndex];
       const valueLabel = String(opt?.textContent || '')
           .replace(/\s+/g, ' ')
           .trim();
       const next = valueLabel || 'Best Sellers';
       if (display.textContent !== next) display.textContent = next;
       display.classList.add('pfbx-sort-value');
       display.setAttribute('role', 'button');
       display.setAttribute('tabindex', '0');
       display.setAttribute('aria-haspopup', 'listbox');
       display.setAttribute('aria-expanded', sort.classList.contains('pfbx-sort-open') ? 'true' : 'false');
       if (select.getAttribute('aria-label') !== 'Sort') {
           select.setAttribute('aria-label', 'Sort');
       }

       // Keep native select for Prefixbox, but block its OS/native menu
       select.setAttribute('tabindex', '-1');
       select.setAttribute('aria-hidden', 'true');
       [
           ['position', 'absolute'],
           ['inset', '0'],
           ['width', '1px'],
           ['height', '1px'],
           ['opacity', '0'],
           ['pointer-events', 'none'],
           ['border', 'none'],
           ['z-index', '-1']
       ].forEach(([k, v]) => select.style.setProperty(k, v, 'important'));

       const menu = pfbxBuildMobileSortMenu(sort, select);

       if (select.getAttribute('data-pfbx-sort-change-bound') !== '1') {
           select.setAttribute('data-pfbx-sort-change-bound', '1');
           select.addEventListener('change', () => pfbxSyncMobileSortDisplay(sort));
       }

       if (sort.classList.contains('pfbx-sort-open') && menu) {
           menu.hidden = false;
       }
   };

   // Document delegation — Prefixbox often replaces the label node, so per-node listeners die
   if (!window.__PFBX_SORT_MENU_DOC__) {
       window.__PFBX_SORT_MENU_DOC__ = true;

       document.addEventListener(
           'click',
           (e) => {
               if (!pfbxIsMobileViewport()) return;

               const option = e.target.closest('.pfbx-sort-option');
               if (option) return; // option handler owns this

               const sort = e.target.closest('#sort-direction');
               if (sort) {
                   // Tap label / chevron / empty sort area → custom menu (not OS select)
                   if (e.target.closest('.pfbx-sort-menu')) return;
                   e.preventDefault();
                   e.stopPropagation();
                   pfbxSyncMobileSortDisplay(sort);
                   pfbxToggleMobileSortMenu(sort);
                   return;
               }

               pfbxCloseMobileSortMenus();
           },
           true
       );

       document.addEventListener(
           'keydown',
           (e) => {
               if (!pfbxIsMobileViewport()) return;
               const display = e.target.closest?.(
                   '#sort-direction .prefixbox-dropdown-displaytext, #sort-direction .pfbx-sort-value'
               );
               if (!display) return;
               const sort = display.closest('#sort-direction');
               if (!sort) return;
               if (e.key === 'Enter' || e.key === ' ') {
                   e.preventDefault();
                   pfbxSyncMobileSortDisplay(sort);
                   pfbxToggleMobileSortMenu(sort);
               } else if (e.key === 'Escape') {
                   pfbxCloseMobileSortMenus();
               }
           },
           true
       );

       document.addEventListener('scroll', () => pfbxCloseMobileSortMenus(), true);
   }

   const pfbxIsMobileDrawerOpen = () => {
       const drawer = document.querySelector('#mobile-drawer-filters');
       if (!drawer) return false;
       const cs = window.getComputedStyle(drawer);
       if (cs.display === 'none' || cs.visibility === 'hidden') return false;
       const rect = drawer.getBoundingClientRect();
       if (rect.width < 40 || rect.height < 40) return false;
       // Open drawer sits on-screen (Prefixbox slides it in)
       return rect.left < window.innerWidth - 20 && rect.right > 20;
   };

   /*
     Canva 12–13 toolbar — CSS-first, no remounting of Prefixbox open button.
     Remounting / nesting .open-off-canvas-button caused open→immediate close.
   */
   const pfbxComposeMobileToolbar = () => {
       if (!pfbxIsMobileViewport()) return;
       // Never touch filter trigger DOM while drawer is open
       if (pfbxIsMobileDrawerOpen()) return;

       const bar = document.querySelector('#pfbx-result-informations');
       if (!bar) return;

       bar.classList.add('pfbx-mobile-toolbar');

       const sort = bar.querySelector('#sort-direction');
       const pageSize = bar.querySelector('#page-size');
       const resultData = bar.querySelector('#result-data');
       const layoutChanger = bar.querySelector('#container-for-custom-layout-changer');

       if (pageSize) pageSize.style.setProperty('display', 'none', 'important');
       if (resultData) resultData.style.setProperty('display', 'none', 'important');
       if (layoutChanger) layoutChanger.style.setProperty('display', 'none', 'important');

       if (sort) {
           sort.classList.add('pfbx-mobile-sort');
           pfbxSyncMobileSortDisplay(sort);
       }

       const filterWrap = bar.querySelector('.mobile-offcanvas');
       const filterContainer = bar.querySelector('.open-filter-button-container');
       const openBtn = bar.querySelector(':scope > .open-off-canvas-button, .open-off-canvas-button');

       // Undo earlier nesting — Prefixbox expects the button as its own control
       if (openBtn && filterContainer && filterContainer.contains(openBtn)) {
           if (filterWrap && filterWrap.parentElement === bar) {
               filterWrap.insertAdjacentElement('afterend', openBtn);
           } else {
               bar.appendChild(openBtn);
           }
       }

       if (openBtn) {
           openBtn.setAttribute('aria-label', 'Open filters');
           openBtn.style.removeProperty('display');
           openBtn.style.removeProperty('visibility');
           openBtn.style.removeProperty('width');
           openBtn.style.removeProperty('height');
           openBtn.style.removeProperty('pointer-events');

           // Real "Filters" label (Prefixbox owns ::before for the icon — CSS ::before text gets overridden)
           let label = bar.querySelector('.pfbx-filters-label');
           if (!label) {
               label = document.createElement('span');
               label.className = 'pfbx-filters-label';
               label.textContent = 'Filters';
               label.addEventListener('click', (e) => {
                   e.preventDefault();
                   e.stopPropagation();
                   openBtn.click();
               });
           } else {
               label.textContent = 'Filters';
               label.style.removeProperty('display');
               label.style.removeProperty('visibility');
           }
           if (label.parentElement !== bar || label.nextElementSibling !== openBtn) {
               openBtn.insertAdjacentElement('beforebegin', label);
           }
       }

       // Kill leftover layout-switcher chrome that leaks into the toolbar
       bar
           .querySelectorAll(
               '#container-for-custom-layout-changer, .prefixbox-layout-button-container, .prefixbox-layout-button, #pfbx-tile-view, #pfbx-list-view'
           )
           .forEach((el) => {
               el.style.setProperty('display', 'none', 'important');
               el.style.setProperty('visibility', 'hidden', 'important');
       });
   };
   
/* ============================================================
   MOBILE ONLY (#mobile-drawer-filters) — Canva Pages 13–14
   Desktop left completely untouched.
   Real DOM:
     - sections: .prefixbox-mobile-filter-container
     - Vendor: .brand
   Never move .pfbx-quick-toggles / desktop toggle nodes.
   ============================================================ */

const pfbxGetMobileDrawer = () => document.querySelector('#mobile-drawer-filters');

const pfbxGetMobileSections = (drawer) =>
    [
        ...drawer.querySelectorAll(
            '.prefixbox-mobile-filter-container, :scope > .prefixbox-filter-container'
        )
    ].filter(
        (el) =>
            !el.classList.contains('prefixbox-mobile-filter-container-header') &&
            !el.classList.contains('prefixbox-filter-container-header')
    );

const pfbxGetFilterTitle = (filter) =>
    (
        filter.querySelector(
            '.prefixbox-filter-group-name, .prefixbox-mobile-filter-group-name, [class*="filter-group-name"]'
        )?.textContent || ''
    )
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ');

const pfbxGetFilterKind = (filter) => {
    const title = pfbxGetFilterTitle(filter);
    const cls = String(filter.className || '').toLowerCase();
    if (cls.includes('price') || title === 'price') return 'price';
    if (cls.includes('brand') || cls.includes('vendor') || title === 'vendor') return 'vendor';
    if (cls.includes('availability') || title.includes('availability')) return 'availability';
    if (cls.includes('tags') || title === 'tags') return 'tags';
    if (cls.includes('categories') || title === 'categories') return 'categories';
    return 'other';
};

const pfbxCleanupMobileJunk = (drawer) => {
    drawer.querySelectorAll('.prefixbox-mobile-filter-container .pfbx-mobile-drawer-toggles').forEach((el) => {
        el.remove();
    });
    drawer.querySelectorAll('.prefixbox-mobile-filter-container .pfbx-mobile-reset').forEach((el) => {
        el.remove();
    });
    const panels = [...drawer.querySelectorAll(':scope > .pfbx-mobile-drawer-toggles')];
    panels.slice(1).forEach((el) => el.remove());
    const resets = [...drawer.querySelectorAll(':scope > .pfbx-mobile-reset')];
    resets.slice(1).forEach((el) => el.remove());
};

/* CSS handles most hide/show; JS marks allowed sections for safety */
const pfbxSimplifyMobileDrawerSections = (drawer) => {
    pfbxGetMobileSections(drawer).forEach((section) => {
        const kind = pfbxGetFilterKind(section);
        const allowed = kind === 'price' || kind === 'vendor';
        section.classList.toggle('pfbx-mobile-keep', allowed);
        section.classList.toggle('pfbx-mobile-hide', !allowed);
    });
};

const pfbxGetSectionToggleBtn = (section) =>
    section.querySelector(
        '[role="button"], .prefixbox-mobile-filter-group-name, .prefixbox-filter-group-name, p.prefixbox-filter-group-name'
    );

const pfbxGetSectionValues = (section) =>
    section.querySelector(
        '.prefixbox-mobile-filter-values-container-toggleable, .prefixbox-filter-values-container-toggleable'
    );

/* Canva: Price ALWAYS expanded — no collapse arrow / no toggle (all category levels) */
const pfbxPriceHasInputs = (price) =>
    !!price?.querySelector(
        '.prefixbox-range-filter-with-input-inputs input, .prefixbox-mobile-range-filter-with-input-inputs input, .min-input input, .max-input input'
    );

const pfbxKeepPriceValuesVisible = (price) => {
    if (!price) return;

    price.classList.add('pfbx-mobile-price-open', 'pfbx-price-locked', 'pfbx-mobile-keep', 'prefixbox-open');
    price.classList.remove('pfbx-mobile-price-closed', 'pfbx-mobile-hide');

    const values = pfbxGetSectionValues(price);
    if (values) {
        values.style.setProperty('display', 'block', 'important');
        values.style.setProperty('height', 'auto', 'important');
        values.style.setProperty('max-height', 'none', 'important');
        values.style.setProperty('min-height', '0', 'important');
        values.style.setProperty('visibility', 'visible', 'important');
        values.style.setProperty('opacity', '1', 'important');
        values.style.setProperty('overflow', 'visible', 'important');
    }

    price
        .querySelectorAll(
            '.prefixbox-range-filter-with-input-inputs, .prefixbox-mobile-range-filter-with-input-inputs'
        )
        .forEach((el) => {
            el.style.setProperty('display', 'flex', 'important');
            el.style.setProperty('visibility', 'visible', 'important');
            el.style.setProperty('opacity', '1', 'important');
            el.style.setProperty('height', 'auto', 'important');
        });

    // Never hide the $ inputs themselves
    price.querySelectorAll('.min-input, .max-input').forEach((el) => {
        el.style.setProperty('display', 'flex', 'important');
        el.style.setProperty('visibility', 'visible', 'important');
        el.style.setProperty('opacity', '1', 'important');
    });

    const slider = price.querySelector('.noUi-target');
    const minHandle = slider?.querySelector('.noUi-handle-lower');
    const maxHandle = slider?.querySelector('.noUi-handle-upper');
    price.querySelectorAll('.min-input input').forEach((input) => {
        input.setAttribute('placeholder', 'From');
        input.style.setProperty('display', 'block', 'important');
        input.style.setProperty('visibility', 'visible', 'important');
        const min = minHandle?.getAttribute('aria-valuemin')?.replace('.0', '');
        if (min && input.value === min) input.value = '';
    });
    price.querySelectorAll('.max-input input').forEach((input) => {
        input.setAttribute('placeholder', 'To');
        input.style.setProperty('display', 'block', 'important');
        input.style.setProperty('visibility', 'visible', 'important');
        const max = maxHandle?.getAttribute('aria-valuemax')?.replace('.0', '');
        if (max && input.value === max) input.value = '';
    });
};

/* Legacy no-op — Price must never collapse */
const pfbxCollapsePriceSection = (price) => {
    pfbxKeepPriceValuesVisible(price);
};

const pfbxForcePriceOpen = (price) => {
    if (!price) return;

    pfbxKeepPriceValuesVisible(price);

    const btn = pfbxGetSectionToggleBtn(price);
    let hasInputs = pfbxPriceHasInputs(price);

    if (btn && !hasInputs) {
        // CRITICAL: do not fake aria-expanded. If Prefixbox thinks it's open but
        // $ inputs never mounted, toggle closed → open so they mount.
        btn.style.removeProperty('pointer-events');
        const wasExpanded = btn.getAttribute('aria-expanded') === 'true';
        try {
            btn.click();
        } catch (e) {
            /* ignore */
        }

        if (wasExpanded) {
            // First click collapsed a stale "open"; second click actually opens.
            setTimeout(() => {
                if (!pfbxPriceHasInputs(price)) {
                    try {
                        btn.click();
                    } catch (e) {
                        /* ignore */
                    }
                }
                pfbxKeepPriceValuesVisible(price);
                pfbxLockPriceHeaderIfReady(price);
            }, 70);
        } else {
            setTimeout(() => {
                pfbxKeepPriceValuesVisible(price);
                if (!pfbxPriceHasInputs(price)) {
                    try {
                        btn.click();
                    } catch (e) {
                        /* ignore */
                    }
                    setTimeout(() => {
                        pfbxKeepPriceValuesVisible(price);
                        pfbxLockPriceHeaderIfReady(price);
                    }, 100);
                } else {
                    pfbxLockPriceHeaderIfReady(price);
                }
            }, 70);
        }
        return;
    }

    pfbxLockPriceHeaderIfReady(price);
};

const pfbxLockPriceHeaderIfReady = (price) => {
    if (!price || !pfbxPriceHasInputs(price)) return;

    pfbxKeepPriceValuesVisible(price);
    const btn = pfbxGetSectionToggleBtn(price);
    if (!btn) return;

    btn.setAttribute('aria-expanded', 'true');
    btn.style.setProperty('pointer-events', 'none', 'important');
    btn.style.setProperty('cursor', 'default', 'important');

    if (btn.getAttribute('data-pfbx-price-locked') === '1') return;
    btn.setAttribute('data-pfbx-price-locked', '1');

    const blockCollapse = (e) => {
        if (!pfbxPriceHasInputs(price)) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        btn.setAttribute('aria-expanded', 'true');
        pfbxKeepPriceValuesVisible(price);
    };
    btn.addEventListener('click', blockCollapse, true);
    price
        .querySelectorAll('.prefixbox-mobile-filter-group-name, .prefixbox-filter-group-name')
        .forEach((label) => {
            if (label.getAttribute('data-pfbx-price-locked') === '1') return;
            label.setAttribute('data-pfbx-price-locked', '1');
            label.style.setProperty('pointer-events', 'none', 'important');
            label.style.setProperty('cursor', 'default', 'important');
            label.addEventListener('click', blockCollapse, true);
        });
};

/* Lock every Price section on the page (desktop sidebar + mobile drawer) */
const pfbxLockAllPriceSections = () => {
    document
        .querySelectorAll(
            '#left-mode-filters .price.prefixbox-filter-container, #drawer-mode-filters .price.prefixbox-filter-container, #mobile-drawer-filters .price.prefixbox-mobile-filter-container, #mobile-drawer-filters .price.prefixbox-filter-container, .price.prefixbox-filter-container, .price.prefixbox-mobile-filter-container'
        )
        .forEach((price) => pfbxForcePriceOpen(price));
};

/* Canva: Vendor collapsed by default — but NEVER steal open state from the shopper */
const pfbxShowVendorList = (vendor) => {
    if (!vendor) return;
    vendor.classList.add('pfbx-mobile-vendor-open', 'pfbx-mobile-keep');
    vendor.classList.remove('pfbx-mobile-vendor-closed', 'pfbx-mobile-hide');

    const values = pfbxGetSectionValues(vendor);
    if (values) {
        values.style.setProperty('display', 'block', 'important');
        values.style.setProperty('visibility', 'visible', 'important');
        values.style.setProperty('height', 'auto', 'important');
        values.style.setProperty('max-height', '50vh', 'important');
        values.style.setProperty('overflow', 'visible', 'important');
        values.style.setProperty('opacity', '1', 'important');
    }

    // Virtuoso needs a FIXED height to render rows. Use count so 1 vendor ≠ 280px gap.
    const countFromClass = (vendor.className.match(/prefixbox-filter-count-(\d+)/) || [])[1];
    const rendered = vendor.querySelectorAll(
        '.prefixbox-mobile-value-filter-value, .prefixbox-value-filter-value'
    ).length;
    const count = Math.max(parseInt(countFromClass || '0', 10) || 0, rendered, 1);
    const rowH = 48;
    const scrollerH = Math.min(Math.max(count * rowH, rowH), Math.floor(window.innerHeight * 0.5));

    vendor.querySelectorAll('[data-virtuoso-scroller="true"]').forEach((scroller) => {
        scroller.style.setProperty('height', scrollerH + 'px', 'important');
        scroller.style.setProperty('max-height', '50vh', 'important');
        scroller.style.setProperty('min-height', '0', 'important');
        scroller.style.setProperty('visibility', 'visible', 'important');
        // 1–few vendors: no scrollbar. Long lists only: allow scroll.
        if (count <= 1) {
            scroller.style.setProperty('overflow', 'hidden', 'important');
            scroller.style.setProperty('overflow-y', 'hidden', 'important');
        } else {
            scroller.style.setProperty('overflow-y', 'auto', 'important');
        }
    });

    // Undo accidental hides on vendor option labels/counts
    vendor
        .querySelectorAll(
            'label, .prefixbox-mobile-filter-text, .prefixbox-mobile-filter-count, .prefixbox-mobile-value-filter-value, .prefixbox-value-filter-value, [data-pfbx-hidden-selected-strip="1"]'
        )
        .forEach((el) => {
            el.style.removeProperty('display');
            el.style.removeProperty('visibility');
            el.style.removeProperty('height');
            el.style.removeProperty('overflow');
            el.removeAttribute('data-pfbx-hidden-selected-strip');
        });

    vendor
        .querySelectorAll('.prefixbox-mobile-value-filter-value, .prefixbox-value-filter-value')
        .forEach((row) => {
            row.style.setProperty('display', 'flex', 'important');
            row.style.setProperty('visibility', 'visible', 'important');
        });

    // After virtuoso paints, shrink again to real row count if available
    setTimeout(() => {
        if (!vendor.classList.contains('pfbx-mobile-vendor-open')) return;
        const live = vendor.querySelectorAll(
            '.prefixbox-mobile-value-filter-value, .prefixbox-value-filter-value'
        ).length;
        const n = Math.max(live || count, 1);
        const h = Math.min(Math.max(n * rowH, rowH), Math.floor(window.innerHeight * 0.5));
        vendor.querySelectorAll('[data-virtuoso-scroller="true"]').forEach((scroller) => {
            scroller.style.setProperty('height', h + 'px', 'important');
            if (n <= 1) {
                scroller.style.setProperty('overflow', 'hidden', 'important');
                scroller.style.setProperty('overflow-y', 'hidden', 'important');
            } else {
                scroller.style.setProperty('overflow-y', 'auto', 'important');
            }
        });
    }, 120);
};

const pfbxHideVendorList = (vendor) => {
    if (!vendor) return;
    vendor.classList.add('pfbx-mobile-vendor-closed', 'pfbx-mobile-keep');
    vendor.classList.remove('pfbx-mobile-vendor-open', 'pfbx-mobile-hide');
    const values = pfbxGetSectionValues(vendor);
    if (values) values.style.setProperty('display', 'none', 'important');
};

const pfbxForceVendorClosed = (vendor) => {
    if (!vendor) return;

    // If shopper already opened Vendor, keep it open and ensure list is visible
    if (vendor.classList.contains('pfbx-mobile-vendor-open')) {
        pfbxShowVendorList(vendor);
        return;
    }

    const btn = pfbxGetSectionToggleBtn(vendor);

    if (vendor.getAttribute('data-pfbx-vendor-init') !== '1') {
        vendor.setAttribute('data-pfbx-vendor-init', '1');

        // Default Canva state: collapsed
        if (btn && btn.getAttribute('aria-expanded') === 'true') btn.click();
        pfbxHideVendorList(vendor);

        if (btn && !btn.getAttribute('data-pfbx-vendor-listen')) {
            btn.setAttribute('data-pfbx-vendor-listen', '1');

            const syncVendor = () => {
                setTimeout(() => {
                    const open = btn.getAttribute('aria-expanded') === 'true';
                    if (open) pfbxShowVendorList(vendor);
                    else pfbxHideVendorList(vendor);
                }, 50);
            };

            btn.addEventListener('click', syncVendor);
            vendor
                .querySelectorAll('.prefixbox-mobile-filter-group-name, .prefixbox-filter-group-name')
                .forEach((label) => {
                    if (label.getAttribute('data-pfbx-vendor-label-listen') === '1') return;
                    label.setAttribute('data-pfbx-vendor-label-listen', '1');
                    label.addEventListener('click', syncVendor);
                });
        }
        return;
    }

    // Soft maintain: only enforce collapsed when shopper has not opened it
    if (
        vendor.classList.contains('pfbx-mobile-vendor-closed') &&
        !vendor.classList.contains('pfbx-mobile-vendor-open')
    ) {
        const values = pfbxGetSectionValues(vendor);
        if (values && btn?.getAttribute('aria-expanded') !== 'true') {
            values.style.setProperty('display', 'none', 'important');
        }
    }
};

const pfbxExpandPriceCollapseVendor = (drawer) => {
    const sections = pfbxGetMobileSections(drawer);
    const price = sections.find((el) => pfbxGetFilterKind(el) === 'price');
    const vendor = sections.find((el) => pfbxGetFilterKind(el) === 'vendor');

    pfbxForcePriceOpen(price);
    pfbxLockAllPriceSections();
    pfbxForceVendorClosed(vendor);
};

/* ============================================================
   MOBILE TOGGLES — always paint Canva layout under FILTERS.
   Availability/Tags stay off-screen (real size) so Prefixbox
   can mount checkboxes without the shopper opening them.
   ============================================================ */

const pfbxNormalizeFacetLabel = (value) =>
    String(value || '')
        .replace(/\(\s*[\d,]+\s*\)/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

const pfbxCollectFacetFilters = (cls) => {
    const sel =
        '.' +
        cls +
        '.prefixbox-mobile-filter-container, .' +
        cls +
        '.prefixbox-filter-container';
    return [...document.querySelectorAll(sel)];
};

const pfbxFindCheckboxByLabels = (root, names) => {
    if (!root) return null;
    const wanted = names.map(pfbxNormalizeFacetLabel);
    const labels = root.querySelectorAll(
        '.prefixbox-filter-text, .prefixbox-mobile-filter-text, label'
    );
    for (const label of labels) {
        const text = pfbxNormalizeFacetLabel(label.textContent);
        if (!wanted.includes(text)) continue;
        const row = label.closest(
            '.prefixbox-value-filter-value, .prefixbox-mobile-value-filter-value, label, li, div'
        );
        const box =
            row?.querySelector('input[type="checkbox"]') ||
            (label.previousElementSibling?.matches?.('input[type="checkbox"]')
                ? label.previousElementSibling
                : null);
        if (box) return box;
    }
    return null;
};

const pfbxFindMobileCheckbox = (key) => {
    if (key === 'in-stock') {
        for (const filter of pfbxCollectFacetFilters('availability')) {
            const box = pfbxFindCheckboxByLabels(filter, ['in stock']);
            if (box) return box;
        }
        return pfbxFindCheckboxByLabels(document, ['in stock']);
    }

    if (key === 'deals' || key === 'sale') {
        const names = key === 'deals' ? ['Deals', 'Deal'] : ['Clearance', 'Sale', 'Clearence'];
        for (const filter of pfbxCollectFacetFilters('tags')) {
            const cb =
                pfbxFindTagCheckboxInFilter(filter, names) ||
                pfbxFindCheckboxByLabels(filter, names);
            if (cb) return cb;
        }
        return pfbxFindCheckboxByLabels(document, names);
    }

    return null;
};

/* ============================================================
   In Stock default:
   - Collection pages: ON by default (unchanged)
   - Search results page: OFF by default (so OOS / exact SKU matches
     remain findable after Enter). Mid-session shopper choice is kept
     until reload / clear-all / reset.
   Search suggestions (autocomplete) are separate and already show OOS.
   ============================================================ */
let pfbxInStockDefaultDone = false;

const pfbxIsSearchPage = () => {
    const path = String(window.location.pathname || '').toLowerCase();
    if (/(^|\/)search\/?$/.test(path) || path.includes('/search')) return true;
    if (document.body?.classList?.contains('template-search')) return true;
    if (document.documentElement?.classList?.contains('template-search')) return true;
    return false;
};

/* ============================================================
   SEARCH ZERO RESULTS — CMS popular products
   Section: search-zero-results (Theme Editor → Search)
   Show only when Prefixbox has 0 product cards / "No results".
   ============================================================ */
const pfbxGetSearchZeroResultsBlock = () => {
    const inner =
        document.getElementById('pfbx-search-zero-results') ||
        document.querySelector('[data-pfbx-zero-results]');
    if (!inner) return null;
    const section = inner.closest('.shopify-section') || inner;
    return { inner, section };
};

const pfbxDetectSearchHasProducts = () => {
    const root =
        document.querySelector('#prefixbox-main') ||
        document.querySelector('#prefixbox-search-container') ||
        null;

    const scope = root || document;
    const productCards = scope.querySelectorAll(
        '#results .prefixbox-product-container, #results .prefixbox-product, .prefixbox-product-container, .prefixbox-search-grid .prefixbox-product'
    );
    if (productCards.length > 0) return true;

    const results =
        document.querySelector('#prefixbox-main #results') || document.querySelector('#results');
    const main = document.querySelector('#prefixbox-main');
    const hay = String((results || main)?.textContent || '').toLowerCase();

    if (/no results?\s*found/.test(hay) || /no\s+products?\s+found/.test(hay) || /0\s+products?/.test(hay)) {
        return false;
    }

    /* Search URL with q= and Prefixbox mounted but no cards yet — wait a bit, then treat as empty */
    const q = new URLSearchParams(window.location.search || '').get('q');
    if (q && main && results && !productCards.length) {
        const ready = main.querySelector('#pfbx-result-informations, #left-mode-filters, #sort-direction');
        if (ready && (results.children.length === 0 || !String(results.textContent || '').trim())) {
            return false;
        }
    }

    return null;
};

const pfbxPlaceSearchZeroResultsBlock = (parts) => {
    if (!parts?.inner) return;
    /* Keep section in template order — do not move DOM (breaks Prefixbox UI) */
    parts.inner.classList.add('pfbx-search-zero-results--full');
    if (parts.section) parts.section.classList.add('pfbx-search-zero-section--active');
};

let pfbxSearchEmptyConfirmed = false;

const pfbxClearSearchEmptyState = () => {
    pfbxSearchEmptyConfirmed = false;
    document.documentElement.classList.remove('pfbx-search-empty');
    document.body?.classList?.remove('pfbx-search-empty');
};

const pfbxSyncSearchZeroResults = () => {
    if (!pfbxIsSearchPage()) {
        pfbxClearSearchEmptyState();
        return;
    }

    const parts = pfbxGetSearchZeroResultsBlock();
    const hasProducts = pfbxDetectSearchHasProducts();

    if (hasProducts === true) {
        pfbxClearSearchEmptyState();
        if (parts?.inner) {
            parts.inner.hidden = true;
            parts.inner.setAttribute('hidden', '');
            parts.inner.setAttribute('aria-hidden', 'true');
        }
        if (parts?.section) parts.section.classList.remove('pfbx-search-zero-section--active');
        return;
    }

    if (hasProducts === null && !pfbxSearchEmptyConfirmed) {
        if (parts?.inner) {
            parts.inner.hidden = true;
            parts.inner.setAttribute('hidden', '');
            parts.inner.setAttribute('aria-hidden', 'true');
        }
        return;
    }

    /* 0 results — only shrink gap + reveal CMS block. Keep Sort / filters / No results. */
    pfbxSearchEmptyConfirmed = true;
    document.documentElement.classList.add('pfbx-search-empty');
    document.body?.classList?.add('pfbx-search-empty');

    if (!parts?.inner) return;

    pfbxPlaceSearchZeroResultsBlock(parts);
    parts.inner.hidden = false;
    parts.inner.removeAttribute('hidden');
    parts.inner.setAttribute('aria-hidden', 'false');
};

const pfbxUrlHasInStockFilter = () => {
    const s = decodeURIComponent(
        String(window.location.search || '') + String(window.location.hash || '')
    ).toLowerCase();
    return /availability/.test(s) && /in[\s_-]*stock/.test(s);
};

const pfbxSyncInStockToggleUi = (on) => {
    document
        .querySelectorAll('[data-pfbx-toggle="in-stock"] .pfbx-toggle-switch')
        .forEach((sw) => sw.classList.toggle('pfbx-toggle-on', !!on));
};

const pfbxAfterInStockDefaultSync = () => {
    setTimeout(() => {
        const latest = pfbxFindInStockCheckbox();
        pfbxSyncInStockToggleUi(!!latest?.checked);
        pfbxRenameSelectedFilters();
        if (typeof pfbxSyncMobileActiveChips === 'function') pfbxSyncMobileActiveChips();
    }, 180);
};

const pfbxEnsureInStockDefault = (opts = {}) => {
    if (opts.reset) pfbxInStockDefaultDone = false;
    if (pfbxInStockDefaultDone && !opts.force) return true;

    const box = pfbxFindInStockCheckbox();
    if (!box) return false;

    /* Search page — keep In Stock OFF by default */
    if (pfbxIsSearchPage()) {
        if (box.checked) {
            box.click();
            pfbxInStockDefaultDone = true;
            pfbxSyncInStockToggleUi(false);
            pfbxAfterInStockDefaultSync();
            return true;
        }

        /* Prefixbox may still apply URL in-stock filter — wait and retry */
        if (pfbxUrlHasInStockFilter()) return false;

        pfbxInStockDefaultDone = true;
        pfbxSyncInStockToggleUi(false);
        return true;
    }

    /* Collection pages — In Stock ON by default */
    if (box.checked) {
        pfbxInStockDefaultDone = true;
        pfbxSyncInStockToggleUi(true);
        return true;
    }

    // Activate real Availability checkbox — updates desktop + mobile Prefixbox state
    box.click();
    pfbxInStockDefaultDone = true;
    pfbxSyncInStockToggleUi(true);
    pfbxAfterInStockDefaultSync();

    return true;
};

/* Park facet off-screen with REAL size so virtuoso mounts options */
const pfbxParkFacetOffscreen = (filter) => {
    if (!filter) return;
    filter.classList.add('pfbx-mobile-facet-source');
    filter.style.setProperty('position', 'fixed', 'important');
    filter.style.setProperty('left', '-12000px', 'important');
    filter.style.setProperty('top', '0', 'important');
    filter.style.setProperty('width', '360px', 'important');
    filter.style.setProperty('height', '480px', 'important');
    filter.style.setProperty('max-height', '480px', 'important');
    filter.style.setProperty('overflow', 'auto', 'important');
    filter.style.setProperty('opacity', '0', 'important');
    filter.style.setProperty('pointer-events', 'none', 'important');
    filter.style.setProperty('visibility', 'visible', 'important');
    filter.style.setProperty('display', 'block', 'important');
    filter.style.setProperty('z-index', '-1', 'important');
    filter.style.setProperty('clip', 'auto', 'important');
};

const pfbxOpenFacetHeader = (filter) => {
    if (!filter) return;
    pfbxParkFacetOffscreen(filter);
    const btn =
        filter.querySelector('[role="button"]') ||
        filter.querySelector('.prefixbox-mobile-filter-group-name, .prefixbox-filter-group-name');
    if (!btn) return;
    const expanded = btn.getAttribute('aria-expanded');
    if (expanded === 'false' || expanded === null) {
        btn.click();
    }
};

const pfbxWaitForCheckbox = (key, timeoutMs = 2500) =>
    new Promise((resolve) => {
        const existing = pfbxFindMobileCheckbox(key);
        if (existing) {
            resolve(existing);
            return;
        }

        const started = Date.now();
        const tick = () => {
            const box = pfbxFindMobileCheckbox(key);
            if (box) {
                resolve(box);
                return;
            }
            if (Date.now() - started >= timeoutMs) {
                resolve(null);
                return;
            }
            setTimeout(tick, 80);
        };
        tick();
    });

/* Force Availability + Tags open off-screen so toggles bind without user clicks */
const pfbxPrimeMobileFacets = (drawer) => {
    const drawerFacets = [...(drawer?.querySelectorAll('.availability, .tags') || [])].filter(
        (el) => el.classList.contains('prefixbox-mobile-filter-container')
    );
    const all = [
        ...drawerFacets,
        ...pfbxCollectFacetFilters('availability'),
        ...pfbxCollectFacetFilters('tags')
    ];
    const seen = new Set();
    all.forEach((filter) => {
        if (!filter || seen.has(filter)) return;
        seen.add(filter);
        pfbxOpenFacetHeader(filter);
    });
};

const pfbxSyncToggleSwitch = (row, key) => {
    const sw = row?.querySelector('.pfbx-toggle-switch');
    const box = pfbxFindMobileCheckbox(key);
    if (sw && box) sw.classList.toggle('pfbx-toggle-on', !!box.checked);
};

const pfbxActivateMobileToggle = async (key, sw) => {
    pfbxPrimeMobileFacets(pfbxGetMobileDrawer());
    let box = pfbxFindMobileCheckbox(key);
    if (!box) box = await pfbxWaitForCheckbox(key, 3000);
    if (box) box.click();
    setTimeout(() => {
        const latest = pfbxFindMobileCheckbox(key);
        if (sw && latest) sw.classList.toggle('pfbx-toggle-on', !!latest.checked);
        pfbxRenameSelectedFilters();
        pfbxSyncMobileActiveChips();
    }, 120);
};

/* ALWAYS show In Stock / Deals / Sale under FILTERS (Canva). Do not wait for accordion clicks. */
const pfbxBuildMobileDrawerToggles = (drawer) => {
    pfbxCleanupMobileJunk(drawer);
    pfbxPrimeMobileFacets(drawer);

    let panel = drawer.querySelector('.pfbx-mobile-drawer-toggles');
    if (!panel) {
        panel = document.createElement('div');
        panel.className = 'pfbx-mobile-drawer-toggles';
    }
    panel.setAttribute('data-pfbx-mobile-toggles', '1');

    const header =
        drawer.querySelector('.prefixbox-mobile-filter-container-header') ||
        [...drawer.children].find((el) => /filters?/i.test((el.textContent || '').trim().slice(0, 20)));

    if (header) header.insertAdjacentElement('afterend', panel);
    else {
        const price = pfbxGetMobileSections(drawer).find((el) => pfbxGetFilterKind(el) === 'price');
        if (price) drawer.insertBefore(panel, price);
        else drawer.insertBefore(panel, drawer.firstChild);
    }

    panel.style.setProperty('display', 'flex', 'important');
    panel.style.setProperty('flex-direction', 'column', 'important');
    panel.style.setProperty('visibility', 'visible', 'important');
    panel.style.setProperty('opacity', '1', 'important');

    const order = [
        ['in-stock', 'In Stock'],
        ['deals', 'Deals'],
        ['sale', 'Clearance']
    ];

    order.forEach(([key, label]) => {
        let row = panel.querySelector(`[data-pfbx-toggle="${key}"]`);
        if (!row) {
            row = document.createElement('div');
            row.className = 'pfbx-toggle-wrapper';
            row.setAttribute('data-pfbx-toggle', key);
            row.innerHTML =
                '<span class="pfbx-toggle-label">' +
                label +
                '</span><label class="pfbx-toggle-switch"><span class="pfbx-toggle-slider"></span></label>';

            const sw = row.querySelector('.pfbx-toggle-switch');
            sw.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                pfbxActivateMobileToggle(key, sw);
            });
            panel.appendChild(row);
        }
        row.style.setProperty('display', 'flex', 'important');
        pfbxSyncToggleSwitch(row, key);
    });

    // Keep Canva order
    order.forEach(([key]) => {
        const row = panel.querySelector(`[data-pfbx-toggle="${key}"]`);
        if (row) panel.appendChild(row);
    });

    if (typeof pfbxSyncSaleToggleLabels === 'function') pfbxSyncSaleToggleLabels();

    return panel;
};

/* After facets mount, hide Deals/Sale when tag option is missing or has 0 results */
const pfbxReconcileOptionalToggles = (drawer) => {
    const panel = drawer.querySelector('.pfbx-mobile-drawer-toggles');
    if (!panel) return;

    const specs = [
        { key: 'deals', names: ['Deals', 'Deal'] },
        { key: 'sale', names: ['Clearance', 'Sale', 'Clearence'] }
    ];

    specs.forEach(({ key, names }) => {
        const row = panel.querySelector(`[data-pfbx-toggle="${key}"]`);
        if (!row) return;
        const box = pfbxFindMobileCheckbox(key);
        const hasResults =
            typeof pfbxTagOptionHasResults === 'function'
                ? pfbxTagOptionHasResults(names)
                : !!box;
        if (drawer.getAttribute('data-pfbx-tags-probed') === '1' && !hasResults) {
            row.style.setProperty('display', 'none', 'important');
        } else if (hasResults) {
            row.style.setProperty('display', 'flex', 'important');
            pfbxSyncToggleSwitch(row, key);
        } else {
            row.style.setProperty('display', 'none', 'important');
        }
    });

    const inStock = panel.querySelector('[data-pfbx-toggle="in-stock"]');
    if (inStock) {
        inStock.style.setProperty('display', 'flex', 'important');
        pfbxSyncToggleSwitch(inStock, 'in-stock');
    }
};

const pfbxBuildMobileDrawerTogglesUntilReady = (drawer, attempt = 0) => {
    pfbxPrimeMobileFacets(drawer);
    pfbxBuildMobileDrawerToggles(drawer);

    const hasInStock = !!pfbxFindMobileCheckbox('in-stock');
    const hasDeals = !!pfbxFindMobileCheckbox('deals');
    const hasSale = !!pfbxFindMobileCheckbox('sale');
    const tagsOpen = pfbxCollectFacetFilters('tags').some((f) =>
        f.querySelector('input[type="checkbox"]')
    );

    if (tagsOpen) drawer.setAttribute('data-pfbx-tags-probed', '1');
    pfbxReconcileOptionalToggles(drawer);

    if ((hasInStock && (hasDeals || hasSale || drawer.getAttribute('data-pfbx-tags-probed') === '1')) || attempt >= 25) {
        pfbxReconcileOptionalToggles(drawer);
        pfbxEnsureInStockDefault();
        return;
    }

    setTimeout(() => {
        if (!pfbxIsMobileViewport()) return;
        const d = pfbxGetMobileDrawer();
        if (d) pfbxBuildMobileDrawerTogglesUntilReady(d, attempt + 1);
    }, 120);
};

const pfbxClearAllFilters = () => {
    const clearBtn =
        document.querySelector('.prefixbox-selected-filters-clear') ||
        document.querySelector('.prefixbox-clear-all-filters') ||
        [...document.querySelectorAll('button, a, span')].find(
            (el) =>
                !el.classList.contains('pfbx-mobile-reset') &&
                !el.classList.contains('pfbx-mobile-reset-all') &&
                /^(clear all|reset all)$/i.test((el.textContent || '').trim())
        );

    if (clearBtn) {
        clearBtn.click();
        setTimeout(() => pfbxEnsureInStockDefault({ reset: true, force: true }), 350);
        return;
    }

    location.href = window.location.pathname;
};

/* ONE Reset at bottom — always after Vendor/Price, never in header */
const pfbxEnsureMobileReset = (drawer) => {
    drawer
        .querySelectorAll('.prefixbox-mobile-filter-container .pfbx-mobile-reset')
        .forEach((el) => el.remove());

    let button = drawer.querySelector(':scope > .pfbx-mobile-reset');
    if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.className = 'pfbx-mobile-reset';
        button.textContent = 'Reset';
        button.addEventListener('click', (e) => {
            e.preventDefault();
            pfbxClearAllFilters();
            setTimeout(pfbxSyncMobileActiveChips, 100);
        });
    }

    drawer.querySelectorAll('.pfbx-mobile-reset').forEach((el) => {
        if (el !== button) el.remove();
    });

    const vendor = drawer.querySelector('.brand.prefixbox-mobile-filter-container');
    const price = drawer.querySelector('.price.prefixbox-mobile-filter-container');
    const anchor = vendor || price;
    if (anchor) anchor.insertAdjacentElement('afterend', button);
    else drawer.appendChild(button);
};

/* Active chips above product grid + Reset all */
const pfbxSyncMobileActiveChips = () => {
    if (!pfbxIsMobileViewport()) {
        document.querySelectorAll('.pfbx-mobile-active-chips').forEach((el) => el.remove());
        return;
    }

    const results =
        document.querySelector('#prefixbox-main #results') || document.querySelector('#results');
    if (!results) return;

    let bar = document.querySelector('.pfbx-mobile-active-chips');
    if (!bar) {
        bar = document.createElement('div');
        bar.className = 'pfbx-mobile-active-chips';
        results.parentElement
            ? results.parentElement.insertBefore(bar, results)
            : results.insertAdjacentElement('beforebegin', bar);
    }

    pfbxCleanCategoryChips();

    const items = [];
    const seen = new Set();

    document
        .querySelectorAll('.prefixbox-selected-filter-value-filter-value, .prefixbox-selected-filter')
        .forEach((chip) => {
            if (chip.classList.contains('pfbx-category-chip')) return;
            if (chip.closest('.pfbx-mobile-active-chips')) return;
            let text = (chip.textContent || '').replace(/\s+/g, ' ').trim().replace(/\s*[×xX]\s*$/, '');
            if (!text || /^(clear all|reset all|reset)$/i.test(text)) return;
            if (/^categories\s*:/i.test(text)) return;
            if (text === 'Sale') text = 'Clearance';
            if (text === 'in stock') text = 'In Stock';
            const key = text.toLowerCase();
            if (seen.has(key)) return;
            seen.add(key);
            items.push({ text, source: chip });
        });

    bar.innerHTML = '';
    if (!items.length) {
        bar.classList.add('pfbx-mobile-chips-empty');
        return;
    }
    bar.classList.remove('pfbx-mobile-chips-empty');

    items.forEach((item) => {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'pfbx-mobile-chip';
        chip.innerHTML =
            '<span class="pfbx-mobile-chip-label"></span><span class="pfbx-mobile-chip-x">×</span>';
        chip.querySelector('.pfbx-mobile-chip-label').textContent = item.text;
        chip.addEventListener('click', () => {
            const remove =
                item.source.querySelector('button, [class*="remove"], [class*="close"], svg') ||
                item.source;
            remove.click();
            setTimeout(pfbxSyncMobileActiveChips, 100);
        });
        bar.appendChild(chip);
    });

    const resetAll = document.createElement('button');
    resetAll.type = 'button';
    resetAll.className = 'pfbx-mobile-reset-all';
    resetAll.textContent = 'Reset all';
    resetAll.addEventListener('click', () => {
        pfbxClearAllFilters();
        setTimeout(pfbxSyncMobileActiveChips, 100);
    });
    bar.appendChild(resetAll);
};

/* ============================================================
   MOBILE DRAWER COMPOSE — single paint, NO ready/hide loop
   ============================================================ */

let pfbxMobileBusy = false;
let pfbxMobileRevealTimer = null;
let pfbxMobileSuppressObserver = false;
let pfbxMobilePainted = false;

const pfbxIsInsideFacetOptions = (el) =>
    !!(
        el &&
        el.closest(
            '.prefixbox-mobile-value-filter-value, .prefixbox-value-filter-value, .prefixbox-mobile-filter-text, .prefixbox-filter-text, .prefixbox-mobile-filter-count, .prefixbox-filter-count, .prefixbox-mobile-value-filter-values, .prefixbox-value-filter-values, .brand.prefixbox-mobile-filter-container, .price.prefixbox-mobile-filter-container, .pfbx-mobile-drawer-toggles, .pfbx-mobile-reset'
        )
    );

const pfbxRestoreWronglyHiddenFacetLabels = (drawer) => {
    if (!drawer) return;
    drawer
        .querySelectorAll(
            '.brand [data-pfbx-hidden-selected-strip="1"], .price [data-pfbx-hidden-selected-strip="1"], .prefixbox-mobile-value-filter-value [data-pfbx-hidden-selected-strip="1"], .prefixbox-value-filter-value [data-pfbx-hidden-selected-strip="1"]'
        )
        .forEach((el) => {
            el.style.removeProperty('display');
            el.style.removeProperty('visibility');
            el.style.removeProperty('height');
            el.style.removeProperty('overflow');
            el.removeAttribute('data-pfbx-hidden-selected-strip');
        });

    // Vendor labels must always be visible when the section is open
    drawer
        .querySelectorAll(
            '.brand.prefixbox-mobile-filter-container label, .brand.prefixbox-mobile-filter-container .prefixbox-mobile-filter-text, .brand.prefixbox-mobile-filter-container .prefixbox-mobile-filter-count'
        )
        .forEach((el) => {
            el.style.removeProperty('display');
            el.style.removeProperty('visibility');
            el.style.removeProperty('height');
            el.style.removeProperty('overflow');
            el.removeAttribute('data-pfbx-hidden-selected-strip');
        });
};

const pfbxHideDrawerSelectedStrip = (drawer) => {
    if (!drawer || !pfbxIsMobileViewport()) return;

    // Undo previous over-aggressive hides on Vendor/Price options
    pfbxRestoreWronglyHiddenFacetLabels(drawer);

    const hideEl = (el) => {
        if (!el || el === drawer) return;
        if (pfbxIsInsideFacetOptions(el)) return;
        if (
            el.classList?.contains('pfbx-mobile-drawer-toggles') ||
            el.classList?.contains('pfbx-mobile-reset') ||
            el.classList?.contains('prefixbox-mobile-filter-container-header') ||
            el.classList?.contains('price') ||
            el.classList?.contains('brand')
        ) {
            return;
        }
        if (
            el.querySelector?.(
                '.pfbx-mobile-drawer-toggles, .price.prefixbox-mobile-filter-container, .brand.prefixbox-mobile-filter-container, .pfbx-mobile-reset'
            )
        ) {
            return;
        }
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('height', '0', 'important');
        el.style.setProperty('overflow', 'hidden', 'important');
        el.setAttribute('data-pfbx-hidden-selected-strip', '1');
    };

    const scopes = [drawer, drawer.parentElement, drawer.parentElement?.parentElement].filter(Boolean);

    scopes.forEach((scope) => {
        if (scope.closest?.('#left-mode-filters')) return;

        scope
            .querySelectorAll(
                '.prefixbox-selected-filters, .prefixbox-selected-filters-clear, .prefixbox-clear-all-filters'
            )
            .forEach((el) => {
                if (el.closest('#left-mode-filters')) return;
                if (el.closest('.pfbx-mobile-active-chips')) return;
                if (pfbxIsInsideFacetOptions(el)) return;
                hideEl(el);
            });

        // Only hide active-strip chips like "Availability: in stock" / "Clear all"
        // NEVER match vendor option counts like "(1108)"
        [...scope.querySelectorAll('div, a, button, p, section')].forEach((el) => {
            if (el.closest('#left-mode-filters') || el.closest('.pfbx-mobile-active-chips')) return;
            if (pfbxIsInsideFacetOptions(el)) return;

            const t = (el.textContent || '').replace(/\s+/g, ' ').trim();
            if (!t || t.length > 80) return;

            const isChipLabel =
                /^availability\s*:/i.test(t) ||
                /^clear all$/i.test(t) ||
                (/^\(\d+\)$/.test(t) && !el.closest('.brand, .price, .availability, .tags'));

            if (!isChipLabel) return;

            const bar = el.closest('.prefixbox-selected-filters, [class*="selected-filters"]') || el.parentElement;
            if (bar && !pfbxIsInsideFacetOptions(bar)) hideEl(bar);
            hideEl(el);
        });
    });

    // Sibling bars above #mobile-drawer-filters (portal chrome)
    const parent = drawer.parentElement;
    if (parent) {
        [...parent.children].forEach((child) => {
            if (child === drawer) return;
            const t = (child.textContent || '').toLowerCase();
            if (t.includes('clear all') || t.includes('availability:')) {
                hideEl(child);
            }
        });
    }

    // Anything before FILTERS heading inside the drawer
    const header = drawer.querySelector('.prefixbox-mobile-filter-container-header');
    if (header) {
        let el = drawer.firstElementChild;
        while (el && el !== header) {
            const next = el.nextElementSibling;
            if (!pfbxIsInsideFacetOptions(el)) hideEl(el);
            el = next;
        }
    }

    // Final safety: vendor labels visible again
    pfbxRestoreWronglyHiddenFacetLabels(drawer);
};

const pfbxSoftMaintainMobileDrawer = (drawer) => {
    if (!drawer) return;
    pfbxMobileSuppressObserver = true;
    try {
        pfbxHideDrawerSelectedStrip(drawer);
        pfbxSimplifyMobileDrawerSections(drawer);
        pfbxBuildMobileDrawerToggles(drawer);
        pfbxExpandPriceCollapseVendor(drawer);
        pfbxEnsureMobileReset(drawer);
        pfbxInitPricePlaceholders();
    } finally {
        setTimeout(() => {
            pfbxMobileSuppressObserver = false;
        }, 50);
    }
};

const pfbxComposeMobileDrawer = (drawer) => {
    pfbxMobileSuppressObserver = true;
    try {
        drawer.classList.add('pfbx-mobile-canva');
        pfbxCleanupMobileJunk(drawer);
        pfbxHideDrawerSelectedStrip(drawer);
        pfbxSimplifyMobileDrawerSections(drawer);
        pfbxPrimeMobileFacets(drawer);
        pfbxBuildMobileDrawerToggles(drawer);
        pfbxExpandPriceCollapseVendor(drawer);
        pfbxEnsureMobileReset(drawer);
        pfbxInitPricePlaceholders();
        pfbxSyncMobileActiveChips();
        pfbxRenameSelectedFilters();
    } finally {
        setTimeout(() => {
            pfbxMobileSuppressObserver = false;
        }, 80);
    }
};

const pfbxRevealMobileDrawer = (drawer) => {
    if (!drawer) return;
    pfbxMobileSuppressObserver = true;
    try {
        pfbxHideDrawerSelectedStrip(drawer);
        pfbxExpandPriceCollapseVendor(drawer);
        pfbxEnsureMobileReset(drawer);
        pfbxInitPricePlaceholders();
        const price = drawer.querySelector('.price.prefixbox-mobile-filter-container');
        if (price) pfbxForcePriceOpen(price);
        drawer.classList.remove('pfbx-mobile-booting');
        drawer.classList.add('pfbx-mobile-ready');
        pfbxMobilePainted = true;
    } finally {
        setTimeout(() => {
            pfbxMobileSuppressObserver = false;
        }, 100);
    }
};

/* Ready = structure present. Do NOT require empty price values (causes blink loop). */
const pfbxIsMobileDrawerLayoutReady = (drawer) => {
    if (!drawer) return false;
    const hasToggles = !!drawer.querySelector(
        '.pfbx-mobile-drawer-toggles [data-pfbx-toggle="in-stock"]'
    );
    const hasPriceInputs = !!drawer.querySelector(
        '.price.prefixbox-mobile-filter-container .prefixbox-mobile-range-filter-with-input-inputs input, .price.prefixbox-mobile-filter-container .prefixbox-range-filter-with-input-inputs input, .price.prefixbox-filter-container .prefixbox-range-filter-with-input-inputs input, .price .min-input input, .price .max-input input'
    );
    const hasVendor = !!drawer.querySelector(
        '.brand.prefixbox-mobile-filter-container, .brand.prefixbox-filter-container'
    );
    const hasReset = !!drawer.querySelector(':scope > .pfbx-mobile-reset');
    return hasToggles && hasPriceInputs && hasVendor && hasReset;
};

const pfbxClearInlineImportant = (el, props) => {
    if (!el) return;
    props.forEach((p) => el.style.removeProperty(p));
};

/* Undo mobile toolbar/drawer DOM + inline styles so desktop matches a fresh load */
const pfbxTeardownMobileLayout = () => {
    pfbxCloseMobileSortMenus();

        document.querySelectorAll('.pfbx-mobile-active-chips').forEach((el) => el.remove());
    document.querySelectorAll('.pfbx-filters-label').forEach((el) => el.remove());
    document.querySelectorAll('.pfbx-sort-menu').forEach((el) => el.remove());

    const bar = document.querySelector('#pfbx-result-informations');
    if (bar) {
        bar.classList.remove('pfbx-mobile-toolbar');

        const pageSize = bar.querySelector('#page-size');
        const resultData = bar.querySelector('#result-data');
        const layoutChanger = bar.querySelector('#container-for-custom-layout-changer');
        pfbxClearInlineImportant(pageSize, ['display']);
        pfbxClearInlineImportant(resultData, ['display']);
        pfbxClearInlineImportant(layoutChanger, ['display']);

        bar
            .querySelectorAll(
                '#container-for-custom-layout-changer, .prefixbox-layout-button-container, .prefixbox-layout-button, #pfbx-tile-view, #pfbx-list-view'
            )
            .forEach((el) => {
                pfbxClearInlineImportant(el, ['display', 'visibility']);
            });

        const sort = bar.querySelector('#sort-direction');
        if (sort) {
            sort.classList.remove('pfbx-mobile-sort', 'pfbx-sort-open');
            const select = sort.querySelector('select.prefixbox-dropdown');
            const display = sort.querySelector('.prefixbox-dropdown-displaytext');
            if (select) {
                select.removeAttribute('tabindex');
                select.removeAttribute('aria-hidden');
                pfbxClearInlineImportant(select, [
                    'position',
                    'inset',
                    'width',
                    'height',
                    'opacity',
                    'pointer-events',
                    'border',
                    'z-index',
                    'margin',
                    'padding',
                    'background',
                    'cursor'
                ]);
            }
            if (display) {
                display.classList.remove('pfbx-sort-value');
                display.removeAttribute('role');
                display.removeAttribute('tabindex');
                display.removeAttribute('aria-haspopup');
                display.removeAttribute('aria-expanded');
                pfbxClearInlineImportant(display, [
                    'display',
                    'pointer-events',
                    'cursor',
                    'position',
                    'z-index'
                ]);
                // Restore Prefixbox default label if we overwrote it
                if (select) {
                    const opt = select.options[select.selectedIndex];
                    const label = String(opt?.textContent || '').replace(/\s+/g, ' ').trim();
                    if (label) display.textContent = label;
                }
            }
        }

        /* Hide mobile Filters icon — desktop uses left sidebar; refresh hides this, resize must too */
        bar
            .querySelectorAll(
                '.open-off-canvas-button, .pfbx-filters-label, .mobile-offcanvas, .open-filter-button-container, #px-filter-button-badge'
            )
            .forEach((el) => {
                el.style.setProperty('display', 'none', 'important');
                el.style.setProperty('visibility', 'hidden', 'important');
            });
    }

    const drawer = pfbxGetMobileDrawer();
    if (drawer) {
        drawer.classList.remove('pfbx-mobile-ready', 'pfbx-mobile-booting', 'pfbx-mobile-canva');
        drawer.querySelectorAll('.pfbx-mobile-drawer-toggles, .pfbx-mobile-reset').forEach((el) => el.remove());
        drawer.querySelectorAll('.pfbx-mobile-keep, .pfbx-mobile-hide, .pfbx-mobile-price-open, .pfbx-price-locked, .pfbx-mobile-facet-source').forEach((el) => {
            el.classList.remove(
                'pfbx-mobile-keep',
                'pfbx-mobile-hide',
                'pfbx-mobile-price-open',
                'pfbx-price-locked',
                'pfbx-mobile-facet-source'
            );
        });
        drawer.querySelectorAll('[data-pfbx-hidden-selected-strip="1"]').forEach((el) => {
            pfbxClearInlineImportant(el, ['display', 'visibility', 'height', 'overflow', 'max-height', 'opacity', 'pointer-events']);
            el.removeAttribute('data-pfbx-hidden-selected-strip');
        });
        // Clear forced visibility/display on price/vendor values
        drawer
            .querySelectorAll(
                '.prefixbox-mobile-filter-values-container-toggleable, .prefixbox-filter-values-container-toggleable, .prefixbox-range-filter-with-input-inputs, .prefixbox-mobile-range-filter-with-input-inputs'
            )
            .forEach((el) => {
                pfbxClearInlineImportant(el, [
                    'display',
                    'height',
                    'max-height',
                    'min-height',
                    'visibility',
                    'opacity',
                    'overflow'
                ]);
            });
    }

        pfbxMobilePainted = false;
    pfbxMobileBusy = false;
};

const pfbxInitMobileDrawer = (forceBoot = false) => {
    if (!pfbxIsMobileViewport()) {
        pfbxTeardownMobileLayout();
        return;
    }

    try {
        pfbxComposeMobileToolbar();
    } catch (e) {
        /* ignore */
    }

    const drawer = pfbxGetMobileDrawer();
    if (!drawer) return;

    // Already painted — soft maintain ONLY (never remove ready / never hide)
    if (!forceBoot && (pfbxMobilePainted || drawer.classList.contains('pfbx-mobile-ready'))) {
        pfbxSoftMaintainMobileDrawer(drawer);
        return;
    }

    if (pfbxMobileBusy) return;

    pfbxMobileBusy = true;
    pfbxMobileSuppressObserver = true;

    try {
        // Hide only on first compose of this open — not on every mutation
        if (!drawer.classList.contains('pfbx-mobile-ready')) {
            drawer.classList.add('pfbx-mobile-booting');
        }

        pfbxComposeMobileDrawer(drawer);
        pfbxPrimeMobileFacets(drawer);

        clearTimeout(pfbxMobileRevealTimer);
        let tries = 0;
        const finish = () => {
            tries += 1;
            pfbxSoftMaintainMobileDrawer(drawer);

            if (pfbxIsMobileDrawerLayoutReady(drawer) || tries >= 20) {
                pfbxRevealMobileDrawer(drawer);
                pfbxMobileBusy = false;
                return;
            }
            pfbxMobileRevealTimer = setTimeout(finish, 80);
        };
        finish();
    } catch (err) {
        pfbxRevealMobileDrawer(drawer);
        pfbxMobileBusy = false;
    }
};

   /* ============================================================
      INIT
      ============================================================ */
   
   let pfbxSidebarUpdating = false;
   let pfbxSidebarTimer = null;
   let pfbxMobileTimer = null;
   let pfbxRepairTimer = null;
   let pfbxObservedLeftEl = null;

   /* Repair only what Prefixbox wiped — safe to run often */
   const pfbxDesktopSidebarNeedsRepair = () => {
       const left = document.querySelector('#left-mode-filters');
       if (!left) return false;

       const hasNavData = !!document.getElementById('pfbx-collection-nav-data');
       const hasNav = !!left.querySelector('.pfbx-metafield-categories');
       if (hasNavData && !hasNav) return true;

       const availability = left.querySelector('.availability.prefixbox-filter-container');
       if (availability) {
           const hasToggle = !!availability.querySelector(
               '.pfbx-toggle-wrapper[data-pfbx-toggle="in-stock"]'
           );
           if (!hasToggle) return true;
       }

       const tags = left.querySelector('.tags.prefixbox-filter-container');
       if (tags && !tags.querySelector('.pfbx-tags-toggles')) return true;

       return false;
   };

   const pfbxRepairDesktopSidebar = () => {
       try {
           pfbxPreserveCollectionSubcats();
           pfbxHideNativeCategoriesFilter(document);
           pfbxInjectMetafieldCategories();
           pfbxBuildDesktopToggles();
           pfbxHideDesktopFiltersLabel();
           pfbxApplyScissorsFacetVisibility();
       } catch (e) {
           /* ignore */
       }
   };

   const pfbxScheduleDesktopRepair = (delay) => {
       clearTimeout(pfbxRepairTimer);
       pfbxRepairTimer = setTimeout(() => {
           pfbxEnsureLeftFiltersObserved();
           /* Re-run tag toggle init so Deals/Sale hide when count is 0 */
           if (typeof pfbxInitTagToggles === 'function') pfbxInitTagToggles();
           if (typeof pfbxApplyScissorsFacetVisibility === 'function') {
               pfbxApplyScissorsFacetVisibility();
           }
           if (pfbxDesktopSidebarNeedsRepair()) {
               pfbxRepairDesktopSidebar();
           }
       }, typeof delay === 'number' ? delay : 80);
   };

   /* Re-bind whenever Prefixbox replaces #left-mode-filters with a new node */
   let pfbxLeftFiltersObserver = null;
   const pfbxEnsureLeftFiltersObserved = () => {
       const left = document.querySelector('#left-mode-filters');
       if (!left) return;

       if (pfbxObservedLeftEl === left && left.getAttribute('data-pfbx-left-observed') === 'true') {
           return;
       }

       pfbxObservedLeftEl = left;
       left.setAttribute('data-pfbx-left-observed', 'true');

       if (pfbxLeftFiltersObserver) {
           try {
               pfbxLeftFiltersObserver.disconnect();
           } catch (e) {
               /* ignore */
           }
       }

       pfbxLeftFiltersObserver = new MutationObserver(() => {
           pfbxScheduleDesktopRepair(50);
       });
       pfbxLeftFiltersObserver.observe(left, { childList: true, subtree: true });
       pfbxScheduleDesktopRepair(30);
   };
   
   const pfbxInitSidebar = () => {
       if (pfbxSidebarUpdating) return;
       clearTimeout(pfbxSidebarTimer);
   
       pfbxSidebarTimer = setTimeout(() => {
           pfbxSidebarUpdating = true;
           const run = (fn) => {
               try {
                   fn();
               } catch (e) {
                   /* keep remaining sidebar features working */
               }
           };
           try {
               run(pfbxRemoveLegacyCanvaNav);
               run(pfbxPreserveCollectionSubcats);
               run(pfbxRepairDesktopSidebar);
               run(pfbxCleanCategoryChips);
               run(pfbxHighlightCurrentCategory);
               run(pfbxInitPricePlaceholders);
               run(pfbxLockAllPriceSections);
               run(pfbxSyncSortShowOptions);
               run(pfbxComposeMobileToolbar);
               run(pfbxEnsureInStockDefault);
               run(pfbxExpandDesktopFacetScrollers);
               run(() => pfbxInitMobileDrawer(false));
               run(pfbxEnsureLeftFiltersObserved);
           } finally {
               setTimeout(() => {
                   pfbxSidebarUpdating = false;
               }, 100);
           }
       }, 80);
   };
   
   let observerTimer = null;
   let previousUrl = location.href;
   
   const pfbxSidebarObserver = new MutationObserver(() => {
       if (pfbxMobileSuppressObserver) return;
       clearTimeout(observerTimer);
   
       observerTimer = setTimeout(() => {
           if (location.href !== previousUrl) {
               const prevPath = previousUrl.split('?')[0].split('#')[0];
               const nextPath = location.href.split('?')[0].split('#')[0];
               previousUrl = location.href;
               pfbxMobilePainted = false;
               if (prevPath !== nextPath) pfbxInStockDefaultDone = false;
               pfbxObservedLeftEl = null;
               pfbxInitSidebar();
               return;
           }
           pfbxScheduleDesktopRepair(60);
           try {
               pfbxPreserveCollectionSubcats();
               pfbxHighlightCurrentCategory();
               pfbxCleanCategoryChips();
               pfbxEnsureInStockDefault();
               pfbxLockAllPriceSections();
               pfbxExpandDesktopFacetScrollers();
           } catch (e) {
               /* ignore */
           }

           clearTimeout(pfbxMobileTimer);
           pfbxMobileTimer = setTimeout(() => pfbxInitMobileDrawer(false), 200);
       }, 200);
   });
   
   if (pfbxFiltersContainer) {
       pfbxSidebarObserver.observe(pfbxFiltersContainer, { childList: true, subtree: true });
       pfbxInitSidebar();
   }
   
   document.addEventListener('DOMContentLoaded', () => {
       pfbxBindIWishButtons();
       pfbxRenameSelectedFilters();
       pfbxInitSidebar();
       pfbxEnsureSkuOnCards();
       pfbxSyncSearchZeroResults();
       setTimeout(pfbxSyncSearchZeroResults, 400);
       setTimeout(pfbxSyncSearchZeroResults, 1200);
   });
   
   let pfbxWasMobileViewport = pfbxIsMobileViewport();
   
   window.addEventListener('resize', () => {
       clearTimeout(pfbxMobileTimer);
       pfbxMobileTimer = setTimeout(() => {
           const isMobile = pfbxIsMobileViewport();
           const crossed = isMobile !== pfbxWasMobileViewport;
           pfbxWasMobileViewport = isMobile;

           if (!isMobile) {
               // Mobile → desktop: strip inline mobile chrome so layout matches refresh
               pfbxTeardownMobileLayout();
               pfbxScheduleDesktopRepair(50);
               pfbxScheduleDesktopRepair(300);
               return;
           }

           // Desktop → mobile (or still mobile): full recompose when crossing
           pfbxInitMobileDrawer(crossed);
           if (crossed) {
               pfbxComposeMobileToolbar();
           }
           pfbxScheduleDesktopRepair(50);
       }, 150);
   });
   
   /* Portal drawer mount — observe once, compose once */
   const pfbxEnsureDrawerObserved = () => {
       const drawer = pfbxGetMobileDrawer();
       if (!drawer) return;

       if (drawer.getAttribute('data-pfbx-drawer-observed') !== 'true') {
           drawer.setAttribute('data-pfbx-drawer-observed', 'true');
           pfbxSidebarObserver.observe(drawer, { childList: true, subtree: true });
           pfbxMobilePainted = false;
           pfbxInitMobileDrawer(true);
           return;
       }

       pfbxInitMobileDrawer(false);
   };

   const pfbxPortalObserver = new MutationObserver(() => {
       if (pfbxMobileSuppressObserver) return;
       clearTimeout(pfbxMobileTimer);
       pfbxMobileTimer = setTimeout(() => {
           pfbxEnsureDrawerObserved();
           pfbxEnsureLeftFiltersObserved();
           pfbxScheduleDesktopRepair(80);
       }, 150);
   });
   if (document.body) {
       pfbxPortalObserver.observe(document.body, { childList: true, subtree: true });
       pfbxEnsureDrawerObserved();
   }

   pfbxEnsureLeftFiltersObserved();
   setTimeout(pfbxEnsureLeftFiltersObserved, 300);
   setTimeout(pfbxEnsureLeftFiltersObserved, 1000);
   setTimeout(pfbxEnsureLeftFiltersObserved, 2500);

   /* Open Filters → compose drawer content. Do NOT strip ready / remount trigger (causes open→close). */
   document.addEventListener(
       'click',
       (e) => {
           if (!pfbxIsMobileViewport()) return;
           if (e.target.closest('#mobile-drawer-filters')) return;
           if (e.target.closest('.close-off-canvas-button')) return;

           const openTrigger = e.target.closest(
               '.open-off-canvas-button, .open-filter-button-container, .mobile-offcanvas, [aria-controls="mobile-drawer-filters"], #mobile-drawer-filters-button, .prefixbox-mobile-filters-button'
           );
           if (!openTrigger) return;

           clearTimeout(pfbxMobileTimer);
           pfbxMobileTimer = setTimeout(() => {
           const drawer = pfbxGetMobileDrawer();
               if (!drawer) return;
               if (drawer.classList.contains('pfbx-mobile-ready')) {
                   pfbxSoftMaintainMobileDrawer(drawer);
               } else {
                   pfbxInitMobileDrawer(true);
               }
           }, 120);
       },
       true
   );

   /* After Prefixbox Clear all / Reset — restore page In Stock default
      (ON on collection, OFF on search) */
   document.addEventListener(
       'click',
       (e) => {
           const el = e.target.closest('button, a, span, [role="button"]');
           if (!el) return;
           if (el.classList?.contains('pfbx-mobile-chip')) return;
           const label = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
           if (label !== 'clear all' && label !== 'reset all' && label !== 'reset') return;
           setTimeout(() => pfbxEnsureInStockDefault({ reset: true, force: true }), 400);
           setTimeout(() => pfbxScheduleDesktopRepair(100), 450);
       },
       true
   );

   /* Heartbeat: catch remounts even when MutationObserver misses the new node */
   setInterval(() => {
       pfbxEnsureLeftFiltersObserved();
       if (pfbxDesktopSidebarNeedsRepair()) {
           pfbxRepairDesktopSidebar();
       }
       try {
           pfbxPreserveCollectionSubcats();
           pfbxHighlightCurrentCategory();
           pfbxEnsureSkuOnCards();
           pfbxEnsureInStockDefault();
           pfbxLockAllPriceSections();
           pfbxExpandDesktopFacetScrollers();
           if (pfbxIsMobileViewport()) pfbxComposeMobileToolbar();
       } catch (e) {
           /* ignore */
       }
       if (pfbxIsMobileViewport() && !pfbxMobileSuppressObserver && !pfbxMobileBusy) {
           const drawer = pfbxGetMobileDrawer();
           if (drawer && drawer.classList.contains('pfbx-mobile-ready')) {
               pfbxSoftMaintainMobileDrawer(drawer);
           } else if (drawer && !pfbxMobilePainted) {
               pfbxInitMobileDrawer(false);
           }
           pfbxSyncMobileActiveChips();
       }
       try {
           pfbxSyncSearchZeroResults();
       } catch (e) {
           /* ignore */
       }
   }, 700);

   /* After expand/collapse of a no-scroll facet, resize THAT list to fit (dynamic) */
   document.addEventListener(
       'click',
       (e) => {
           const root = e.target.closest('#left-mode-filters');
           if (!root) return;
           const header = e.target.closest(
               '.prefixbox-filter-group-name, .prefixbox-mobile-filter-group-name, [role="button"]'
           );
           if (!header) return;
           const section = header.closest('.prefixbox-filter-container');
           if (!section || !pfbxIsNoScrollDesktopFacet(section)) return;
           const fit = () => pfbxFitOneDesktopFacet(section);
           setTimeout(fit, 40);
           setTimeout(fit, 120);
           setTimeout(fit, 280);
           setTimeout(fit, 500);
           setTimeout(() => pfbxScheduleDesktopRepair(80), 100);
       },
       true
   );

   /* ============================================================
      Desktop cards — equal price block height per visual row
      (long price may wrap; points / title / ATC stay aligned)
      ============================================================ */
   const PFBX_PRICE_SEL = '#results .tile-view .prefixbox-search-product-footer';
   let pfbxPriceRaf = 0;

   const pfbxEqualizePriceRows = () => {
       pfbxPriceRaf = 0;
       const footers = Array.from(document.querySelectorAll(PFBX_PRICE_SEL));
       footers.forEach((f) => { f.style.minHeight = ''; });
       if (pfbxIsMobileViewport() || !footers.length) return;

       const rows = new Map();
       footers.forEach((f) => {
           const card = f.closest('.prefixbox-product-container') || f;
           const top = Math.round(card.getBoundingClientRect().top + window.scrollY);
           if (!rows.has(top)) rows.set(top, []);
           rows.get(top).push(f);
       });

       const contentHeight = (f) => {
           const top = f.getBoundingClientRect().top;
           let bottom = top;
           Array.from(f.children).forEach((c) => {
               const r = c.getBoundingClientRect();
               if (r.height > 0 && r.bottom > bottom) bottom = r.bottom;
           });
           return bottom - top;
       };

       rows.forEach((group) => {
           if (group.length < 2) return;
           const heights = group.map(contentHeight);
           const max = Math.max(...heights);
           if (max - Math.min(...heights) < 1) return;
           group.forEach((f) => { f.style.minHeight = `${Math.ceil(max)}px`; });
       });
   };

   const pfbxSchedulePriceRows = () => {
       if (pfbxPriceRaf) cancelAnimationFrame(pfbxPriceRaf);
       pfbxPriceRaf = requestAnimationFrame(pfbxEqualizePriceRows);
   };

   const pfbxPriceResultsObserver = new MutationObserver(pfbxSchedulePriceRows);
   let pfbxPriceLastResultsWidth = 0;
   const pfbxPriceResizeObserver = typeof ResizeObserver === 'function'
       ? new ResizeObserver((entries) => {
           const w = Math.round(entries[0].contentRect.width);
           if (w === pfbxPriceLastResultsWidth) return;
           pfbxPriceLastResultsWidth = w;
           pfbxSchedulePriceRows();
       })
       : null;
   const pfbxObservePriceResults = () => {
       const results = document.querySelector('#prefixbox-main #results') || document.querySelector('#results');
       if (!results || results.getAttribute('data-pfbx-price-rows') === 'true') return;
       results.setAttribute('data-pfbx-price-rows', 'true');
       pfbxPriceResultsObserver.observe(results, { childList: true, subtree: true });
       if (pfbxPriceResizeObserver) pfbxPriceResizeObserver.observe(results);
       pfbxSchedulePriceRows();
   };

   let pfbxPriceLastWidth = window.innerWidth;
   window.addEventListener('resize', () => {
       if (window.innerWidth === pfbxPriceLastWidth) return;
       pfbxPriceLastWidth = window.innerWidth;
       pfbxSchedulePriceRows();
   });
   window.addEventListener('load', pfbxSchedulePriceRows);
   if (document.fonts && document.fonts.ready) document.fonts.ready.then(pfbxSchedulePriceRows);

   pfbxObservePriceResults();
   setInterval(pfbxObservePriceResults, 1000);

} /* end __PFBX_PLP_CUSTOM__ guard */
